// interface DefaultQuote {
//     sentence: string;
//     author: string;
// }

export const defaultQuotes= [
  {
    sentence: "우리는 우물이 마르기 전까지 물의 중요성을 결코 알지 못한다.",
    author: "토마스 풀러",
  },
  {
    sentence:
      "모든 위험이 사라질 때까지 항해를 떠나지 않는 사람은 결코 바다에 나서서는 안 된다.",
    author: "토마스 풀러",
  },
  {
    sentence: "큰 희망은 큰 사람을 만든다.",
    author: "토마스 풀러",
  },
  {
    sentence: "바보는 방황하고 현명한 사람은 여행을 떠난다.",
    author: "토마스 풀러",
  },
  {
    sentence:
      "선물로 친구를 사지 말라, 선물을 주지 않으면 그 친구의 사랑도 끝날 것이다.",
    author: "토마스 풀러",
  },
  {
    sentence: "말수가 적고 친절한 것은 여성의 가장 좋은 장식이다.",
    author: "레프 니콜라예비치 톨스토이",
  },
  {
    sentence: "병에 걸리기 전까지는 건강의 중요성을 알지 못한다.",
    author: "토마스 풀러",
  },
  {
    sentence: "덮여 있는 책은 블록일 뿐이다.",
    author: "토마스 풀러",
  },
  {
    sentence: "모든 일은 어려운 고비를 넘겨야 쉬워진다.",
    author: "토마스 풀러",
  },
  {
    sentence: "비가 옵니다. 다정한 손님같이 비가 옵니다.",
    author: "빗소리 中 - 주요한",
  },
  {
    sentence:
      "독서만큼 값이 싸면서도 오랫동안 즐거움을 누릴 수 있는 것은 없다.",
    author: "몽테뉴",
  },
  {
    sentence: "세월이 가는지 오는지도 모른다.",
    author: "속담",
  },
  {
    sentence: "나는 너에게, 너는 나에게 잊혀지지 않은 하나의 의미가 되고 싶다.",
    author: "꽃 中 - 김춘수",
  },
  {
    sentence: "산은 모든 자연 풍경의 시작이요, 끝이다.",
    author: "명언",
  },
  {
    sentence: "참외도 까마귀 파먹은 것이 다르다.",
    author: "속담",
  },
  {
    sentence: "자기 자신을 아는 것은 참된 진보이다.",
    author: "안데르센",
  },
  {
    sentence: "새 도랑 내지 말고 옛 도랑 메우지 말라.",
    author: "속담",
  },
  {
    sentence:
      "안 살이 내 살이면 천 리라도 찾아가고 밭 살이 내 살이면 십 리라도 가지 마라.",
    author: "속담",
  },
  {
    sentence: "큰일은 언제나 사소한 데서 시작된다.",
    author: "노자(老子)",
  },
  {
    sentence: "죽은 정이 하루에 천 리 간다.",
    author: "속담",
  },
  {
    sentence: "폭풍이 지난 뒤에 고요가 온다.",
    author: "속담",
  },
  {
    sentence: "한 푼 돈을 우습게 여기면 한 푼 돈에 울게 된다.",
    author: "속담",
  },
  {
    sentence: "가장 높이 나는 갈매기가 가장 멀리 본다.",
    author: "갈매기의 꿈 中 - 리처드 바크",
  },
  {
    sentence: "죽을 변을 만나면 살길도 있다.",
    author: "속담",
  },
  {
    sentence: "상제가 울어도 제상에 가자미 물어 가는 것은 안다.",
    author: "속담",
  },
  {
    sentence: "지혜로운 자는 물을 좋아하고 어진 자는 산을 좋아한다.",
    author: "공자(孔子)",
  },
  {
    sentence: "입찬말은 묘 앞에 가서 하여라.",
    author: "속담",
  },
  {
    sentence: "큰 말이 나가면 작은 말이 큰 말 노릇 한다.",
    author: "속담",
  },
  {
    sentence: "부지런한 농민에게는 좋은 땅과 나쁜 땅이 따로 없다.",
    author: "속담",
  },
  {
    sentence: "두뇌를 압도하기보다는 마음을 얻어냄이 더 확고한 정복이다.",
    author: "명언",
  },
  {
    sentence: "백지장도 맞들면 낫다.",
    author: "속담",
  },
  {
    sentence: "말은 행동의 거울이다.",
    author: "솔론",
  },
  {
    sentence: "제 사랑 제가 끼고 있다.",
    author: "속담",
  },
  {
    sentence: "젊음은 그 자체가 하나의 빛이다.",
    author: "요한 볼프강 폰 괴테",
  },
  {
    sentence: "나와 하늘과 하늘 아래 푸른 산뿐이로다.",
    author: "슬픈 구도 中 - 신석정",
  },
  {
    sentence:
      "산속의 도둑을 피하기는 쉽지만, 마음속의 도둑을 피하는 것은 어렵다.",
    author: "속담",
  },
  {
    sentence: "제 하고 싶어서 하는 일은 힘든 줄 모른다.",
    author: "속담",
  },
  {
    sentence: "가까운 이웃이 먼 친척보다 낫다.",
    author: "속담",
  },
  {
    sentence:
      "먼 곳으로 항해하는 배가 풍파를 만나지 않고 조용히만 갈 수는 없다. 풍파는 언제나 전진하는 자의 벗이다.",
    author: "프리드리히 빌헬름 니체",
  },
  {
    sentence: "독서가 정신에 대함은 준비 운동이 육체에 대함과 마찬가지이다.",
    author: "명언",
  },
  {
    sentence: "명성은 젊은이에게 광채를 주고, 노인에게는 위엄을 가져다 준다.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence: "일은 내 몫이 더 많아 보이고 먹을 것은 남의 것이 커 보인다.",
    author: "북한 속담",
  },
  {
    sentence: "백을 가지고 백을 보여 주다.",
    author: "속담",
  },
  {
    sentence: "호랑이는 세 살 먹은 어린애가 봐도 호랑인 줄 안다.",
    author: "속담",
  },
  {
    sentence: "토끼 입에 콩가루 먹은 것 같다.",
    author: "속담",
  },
  {
    sentence: "이따금 그대의 즐거움을 그대의 진지한 직업에 동참시켜라.",
    author: "속담",
  },
  {
    sentence: "세월은 사람을 기다려 주지 않는다.",
    author: "속담",
  },
  {
    sentence: "콩밭에 소 풀어놓고도 할 말이 있다.",
    author: "속담",
  },
  {
    sentence: "하늘 높은 줄만 알고 땅 넓은 줄은 모른다.",
    author: "동양 속담",
  },
  {
    sentence: "제 꾀에 제가 넘어간다.",
    author: "속담",
  },
  {
    sentence: "아버지의 덕행은 최고의 유산이다.",
    author: "명언",
  },
  {
    sentence: "덕행은 스스로를 정당화하면 가치가 떨어진다.",
    author: "볼테르",
  },
  {
    sentence: "가까운 데 집은 깎이고 먼데 절은 비친다.",
    author: "속담",
  },
  {
    sentence: "도끼가 제 자루 못 찍는다.",
    author: "속담",
  },
  {
    sentence: "나중에 보자는 양반 무섭지 않다.",
    author: "속담",
  },
  {
    sentence: "매도 먼저 맞는 사람이 낫다.",
    author: "속담",
  },
  {
    sentence: "업은 자식에게 배운다.",
    author: "속담",
  },
  {
    sentence: "자식은 내 자식이 커 보이고 벼는 남의 벼가 커 보인다.",
    author: "속담",
  },
  {
    sentence:
      "자신의 실력이 불충분하다는 것을 아는 것이 자신의 실력을 충실하게 한다.",
    author: "명언",
  },
  {
    sentence: "저는 잘난 백정으로 알고 남은 헌 정승으로 안다.",
    author: "속담",
  },
  {
    sentence: "저 팽이가 돌면 이 팽이도 돈다.",
    author: "속담",
  },
  {
    sentence: "큰 쌀독 열어 놓고 손님 대접한다.",
    author: "속담",
  },
  {
    sentence: "결혼은 하늘에서 맺어지고 땅에서 완성되는 것이다.",
    author: "명언",
  },
  {
    sentence: "듣기 좋은 이야기도 늘 들으면 싫다.",
    author: "속담",
  },
  {
    sentence:
      "만나고, 알고, 사랑하고, 그리고 이별하는 것은 모든 인간의 공통된 슬픈 이야기이다.",
    author: "콜르리지",
  },
  {
    sentence: "인간의 진실한 부는 이 세상에서 행하는 착한 일이다.",
    author: "명언",
  },
  {
    sentence: "큰 북에서 큰 소리 난다.",
    author: "속담",
  },
  {
    sentence: "마지막에 웃는 자가 가장 잘 웃는 자이다.",
    author: "속담",
  },
  {
    sentence: "남 잡으려다가 제가 잡힌다.",
    author: "속담",
  },
  {
    sentence: "평안하게 자유롭게 살고 싶거든 없어도 살 수 있는 것을 멀리하라.",
    author: "레프 니콜라예비치 톨스토이",
  },
  {
    sentence: "어른 없는 데서 자라났다.",
    author: "속담",
  },
  {
    sentence: "어물전 망신은 꼴뚜기가 시킨다.",
    author: "속담",
  },
  {
    sentence: "산 입에 거미줄 치랴",
    author: "속담",
  },
  {
    sentence: "죽을 고비에 빠진 사람은 살 구멍을 찾아낸다.",
    author: "속담",
  },
  {
    sentence: "실 엉킨 것은 풀어도, 노 얽힌 것은 못 푼다.",
    author: "속담",
  },
  {
    sentence: "같은 세계이지만 마음이 다르면 지옥도 되고 천국도 된다.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence:
      "명성을 얻은 예술가는 그 때문에 괴로워한다. 따라서 그들의 처녀작이 때로는 최고다.",
    author: "루트비히 판 베토벤",
  },
  {
    sentence: "종로에서 뺨 맞고 한강에서 눈 흘긴다.",
    author: "속담",
  },
  {
    sentence: "큰 고기는 중간 고기를 먹고 중간 고기는 작은 고기를 먹는다.",
    author: "속담",
  },
  {
    sentence: "나는 대단한 인간이 아니다. 노력하는 노인일 뿐이다.",
    author: "넬슨 만델라",
  },
  {
    sentence:
      "비극의 밑바닥에는 언제나 어떤 아름다운 것이 있음으로해서 나는 비극을 사랑한다.",
    author: "찰리 채플린",
  },
  {
    sentence: "나는 세계 시민이다.",
    author: "디오게네스",
  },
  {
    sentence: "상시에 먹은 마음이 꿈에도 있다.",
    author: "속담",
  },
  {
    sentence: "성인도 하루에 죽을 말을 세 번 한다.",
    author: "속담",
  },
  {
    sentence: "자기가 할 수 있는 일은 남에게 미루지 마라.",
    author: "공자(孔子)",
  },
  {
    sentence: "한 가지 일을 경험하지 않으면 한 가지 지혜가 자라지 않는다.",
    author: "명심보감(明心寶鑑)",
  },
  {
    sentence: "쇠뿔도 단김에 빼라.",
    author: "속담",
  },
  {
    sentence: "가장 훌륭한 인간은 모든 사람을 사랑하는 사람이다.",
    author: "마호메트",
  },
  {
    sentence: "가장 깊은 감정은 항상 침묵속에 있다.",
    author: "토마스 무어",
  },
  {
    sentence: "가장 깊은 진리는 가장 깊은 사랑에 의해서만 열린다.",
    author: "하인리히 하이네",
  },
  {
    sentence: "쇠귀에 경 읽기",
    author: "속담",
  },
  {
    sentence: "잇새도 어우르지 않는다.",
    author: "속담",
  },
  {
    sentence: "송곳 박을 땅도 없다.",
    author: "속담",
  },
  {
    sentence:
      "나는 알몸으로 이 세상에 태어났다. 따라서 나는 이 세상을 떠날 때도 알몸으로 가지 않을 수 없다.",
    author: "미겔 데 사아베드라 세르반테스",
  },
  {
    sentence:
      "나는 언제나 친구나 조국을 위하여 목숨 바치기를 두려워하지 않는다.",
    author: "호라티우스",
  },
  {
    sentence: "나는 여자의 맹세를 물에 적어놓는다.",
    author: "소포클레스",
  },
  {
    sentence: "나는 우리나라가 세계에서 가장 아름다운 나라가 되기를 원한다.",
    author: "백범 김구",
  },
  {
    sentence:
      "우리나라가 독립하여 정부가 생기거든 그 집의 뜰을 쓸고 유리창을 닦은 일을 해 보고 죽게 하소서!",
    author: "백범 김구",
  },
  {
    sentence:
      "나는 이제까지 토지를 사랑해왔다. 토지는 언제나 인간보다 좋은 것이었다.",
    author: "헤밍웨이",
  },
  {
    sentence:
      "인간은 일시적으로 겨우 소수의 사람들밖에 관심을 가질 수 없는 것이다.",
    author: "헤밍웨이",
  },
  {
    sentence: "나는 인간이었다. 그것은 싸우는 자란 것을 의미한다.",
    author: "요한 볼프강 폰 괴테",
  },
  {
    sentence:
      "나는 인내하는 데에는 마음을 강하게 하고, 욕심을 부리는 데에는 마음을 둔하게 하고 있다.",
    author: "몽테뉴",
  },
  {
    sentence: "나는 완고한 덕보다는 융통성이 있는 악덕을 좋아한다.",
    author: "몰리에르",
  },
  {
    sentence: "나는 일찍이 고독만큼 사이좋은 친구를 찾아 본 일이 없다.",
    author: "H.D.도로",
  },
  {
    sentence: "동정은 최고의 모욕이다.",
    author: "프리드리히 빌헬름 니체",
  },
  {
    sentence:
      "조국의 독립과 자유를 회복하기 위하여 한인 애국단의 일원이 되어 적국의 수괴를 죽이기로 맹세하나이다.",
    author: "이봉창 열사",
  },
  {
    sentence:
      "나는 타인의 고통에 동정할 수는 있지만 그들의 즐거움에 공감할 수 없다.",
    author: "토머스 헨리 헉슬리",
  },
  {
    sentence: "나는 평화의 수단으로서 밖에는 아직 전쟁을 주장해 본 일이 없다.",
    author: "유리시즈 그란트",
  },
  {
    sentence:
      "나라가 없고서 한 집과 한 몸이 있을 수 없고, 민족이 천대받을 때 혼자만이 영광을 누릴 수 없다.",
    author: "도산 안창호",
  },
  {
    sentence:
      "나 하나를 건전한 인격으로 만드는 것이 우리 민족을 건전하게 만드는 유일한 길이다.",
    author: "도산 안창호",
  },
  {
    sentence: "진리는 반드시 따르는 자 있고, 정의는 반드시 이루는 날 있다.",
    author: "도산 안창호",
  },
  {
    sentence: "나라가 어지러울 때는 돈이 있고 지위가 높다는 것은 수치이다.",
    author: "공자(孔子)",
  },
  {
    sentence: "돈이란 훌륭한 하인이기도 하지만, 나쁜 주인이기도 하다.",
    author: "벤자민 프랭클린",
  },
  {
    sentence: "돈이 많아지면 곧 미덕은 감소된다.",
    author: "베베르",
  },
  {
    sentence:
      "어느 목적지에 가고자 여행하는 것이 아니고 그저 가기 위해서 여행한다. 나는 여행을 위해서 여행한다.",
    author: "로버트 루이스 스티븐슨",
  },
  {
    sentence:
      "나를 가장 잘 아는 자를 친구로 하고, 나를 가장 잘 모르는 자를 적으로 삼는다면 그보다 더 좋은 일은 없다.",
    author: "보 나르",
  },
  {
    sentence:
      "나쁜 책을 읽고 몸을 버렸다는 어느 소녀의 이야기를 들어본 적이 없다.",
    author: "워커",
  },
  {
    sentence: "나에게 자유를 다오, 그렇지 않으면 죽음을 다오.",
    author: "패드릭 핸리",
  },
  {
    sentence: "나라가 부패하면 할수록 이에 비례하여 법률이 늘어난다.",
    author: "격언",
  },
  {
    sentence: "새 잡아 잔치할 것을 소 잡아 잔치한다.",
    author: "속담",
  },
  {
    sentence: "가을에는 기도하게 하소서.",
    author: "가을의 기도 中 - 김현승",
  },
  {
    sentence: "돈이 없으면 적막강산이요, 돈이 있으면 금수강산이라.",
    author: "속담",
  },
  {
    sentence: "우러러 하늘에도 부끄럽지 않고 굽어 땅에도 부끄럽지 않다.",
    author: "속담",
  },
  {
    sentence: "내 몸이 중이면 중의 행세를 해라.",
    author: "속담",
  },
  {
    sentence: "일꾼을 박대하면 당일로 망한다.",
    author: "속담",
  },
  {
    sentence: "부자의 겸손은 가난한 사람의 벗이 된다.",
    author: "팔만대장경",
  },
  {
    sentence: "소가 말이 없어도 열두 가지 덕이 있다.",
    author: "속담",
  },
  {
    sentence: "내 것도 내 것 네 것도 내 것",
    author: "출처 불명",
  },
  {
    sentence: "꽁지 빠진 새 같다.",
    author: "속담",
  },
  {
    sentence: "울 수 없으니까 웃는다.",
    author: "속담",
  },
  {
    sentence:
      "나의 인생 신조는, 일로 즐거움을 삼고 즐거움을 또한 나의 가장 큰 일로 삼는 것이다.",
    author: "아이론 바하",
  },
  {
    sentence: "나의 취미는 귀족적이고 나의 행동은 민주적이다.",
    author: "위고",
  },
  {
    sentence: "나이는 사랑과 같아 숨길 수 없다.",
    author: "데커",
  },
  {
    sentence: "도가 지나친 겸손은 허영심이다.",
    author: "폰 코체뷰에",
  },
  {
    sentence: "낙천주의자는 우매하고 비관주의자는 무정하다.",
    author: "콕토",
  },
  {
    sentence:
      "낙도박을 즐기는 모든 인간은, 불확실한 것을 얻기 위해서 확실한 것을 걸고 내기를 한다.",
    author: "파스칼",
  },
  {
    sentence: "큰 목표를 이루고 싶으면 허락을 구하지 마라.",
    author: "명언",
  },
  {
    sentence: "독립이 자유롭게 사는 조건이라면 여자는 결혼해서는 안된다.",
    author: "자멘 그리어",
  },
  {
    sentence: "상황을 가장 잘 활용하는 사람이 가장 좋은 상황을 맞는다.",
    author: "존 우든",
  },
  {
    sentence: "창조적인 삶을 살려면 내가 틀릴지도 모른다는 공포를 버려야 한다.",
    author: "명언",
  },
  {
    sentence:
      "일반적인 것을 잃을 위험을 감수하지 않으면 평범한 것에 만족해야 한다.",
    author: "짐 론",
  },
  {
    sentence:
      "신뢰의 이유는 안전하거나 확실해서가 아니라, 위험을 감수할 용의가 있어서이다.",
    author: "명언",
  },
  {
    sentence: "추구할 수 있는 용기가 있다면 우리의 모든 꿈은 이뤄질 수 있다.",
    author: "윌트 디즈니",
  },
  {
    sentence:
      "기다리는 사람에게 좋은 일이 생기지만, 찾아 나서는 사람에게는 더 좋은 일이 생긴다.",
    author: "명언",
  },
  {
    sentence: "늘 하던 대로 하면 늘 얻던 것을 얻는다.",
    author: "명언",
  },
  {
    sentence: "열정을 잃지 않고 실패에서 실패로 걸어가는 것이 성공이다.",
    author: "원스턴 처칠",
  },
  {
    sentence: "애벌레가 세상이 끝났다고 생각하는 순간 나비로 변했다.",
    author: "속담",
  },
  {
    sentence:
      "성공한 사업가들은 긍정적인 에너지를 주는 사람들이지 가져가는 사람들이 아니다.",
    author: "명언",
  },
  {
    sentence: "기회는 일어나는 것이 아니라 만들어내는 것이다.",
    author: "크리스 그로서",
  },
  {
    sentence:
      "성공한 사람이 되려고 노력하기보다 가치 있는 사람이 되려고 노력하라.",
    author: "아인슈타인",
  },
  {
    sentence:
      "나는 실패한 게 아니다. 나는 잘 되지 않는 방법 만 가지를 발견한 것이다.",
    author: "토마스 에디슨",
  },
  {
    sentence:
      "당신이 자신에 대해서 생각하는 것은 다른 사람들이 당신에 대해서 생각하는 것보다 훨씬 중요하다.",
    author: "루시우스 아니에우스 세네카",
  },
  {
    sentence:
      "대도시에서는 우정이 뿔뿔이 흩어진다. 이웃이라는 가까운 교제는 찾아 볼 수 없다.",
    author: "프란시스 베이컨",
  },
  {
    sentence:
      "남들이 당신에게 던진 벽돌들로 탄탄한 기반을 쌓을 수 있어야 성공한다.",
    author: "데이비드 브링클리",
  },
  {
    sentence:
      "당신이 허락해주지 않으면 아무도 당신이 열등감을 느끼게 만들 수 없다.",
    author: "엘리너 루즈벨트",
  },
  {
    sentence:
      "성공적인 삶의 비밀은 무엇을 하는 게 자신의 운명인지 찾아낸 다음 그걸 하는 것이다.",
    author: "헨리 포드",
  },
  {
    sentence: "지옥을 겪고 있다면 계속 겪어 나가라.",
    author: "윈스턴 처칠",
  },
  {
    sentence:
      "자기가 세상을 바꿀 수 있다고 생각할 정도로 미친 사람들이 세상을 바꾼다.",
    author: "명언",
  },
  {
    sentence: "언성을 높이지 말고 논거를 강화하라.",
    author: "명언",
  },
  {
    sentence: "때가 오면 모든 것이 분명해진다. 시간은 진리의 아버지이다.",
    author: "타블레",
  },
  {
    sentence: "괴로운 시련처럼 보이는 것이 뜻밖의 좋은 일일 때가 많다.",
    author: "오스카 와일드",
  },
  {
    sentence:
      "삶의 의미는 자신의 재능을 발견하는 것이다. 삶의 목적은 그것을 나눠주는 것이다.",
    author: "명언",
  },
  {
    sentence: "광기와 천재성 사이의 거리는 성공으로만 측정된다.",
    author: "브루스 페어스타인",
  },
  {
    sentence:
      "잘못된 것들을 쫓아다니는 것을 그만두면 옳은 일들이 당신을 따라잡을 기회가 생긴다.",
    author: "롤리다스칼",
  },
  {
    sentence:
      "위대한 것으로 향하기 위해 좋은 것을 포기하는 걸 두려워하지 마라.",
    author: "존 록펠러",
  },
  {
    sentence: "게으른 예술가가 만든 명작은 없다.",
    author: "명언",
  },
  {
    sentence: "간단하게 설명할 수 없으면 제대로 이해하지 못하는 것이다.",
    author: "아인슈타인",
  },
  {
    sentence: "주고 기억하지 않고, 받고 잊지 않는 사람들에게 복이 있나니.",
    author: "명언",
  },
  {
    sentence: "매일 당신을 두렵게 만드는 일을 하나씩 하라.",
    author: "명언",
  },
  {
    sentence: "놀라운 일을 하려고 노력조차 하지 않을 거면 살아 있어서 뭐하나.",
    author: "명언",
  },
  {
    sentence: "인생이란 자신을 찾는 것이 아니라 자신을 만드는 것이다.",
    author: "롤리 다스칼",
  },
  {
    sentence: "이 세상에 재능이 있는데 성공하지 못한 사람보다 더 흔한 건 없다.",
    author: "명언",
  },
  {
    sentence:
      "지식이란 자기가 그 만큼 배웠다는 교만이고, 지혜는 자기가 더 이상 알지 못한다는 겸손이다.",
    author: "윌리엄 쿠퍼",
  },
  {
    sentence: "당신의 문제가 문제가 아니라 당신의 반응이 문제다.",
    author: "명언",
  },
  {
    sentence: "뭐든 할 수 있지만 모든 걸 할 수 있는 건 아니다.",
    author: "명언",
  },
  {
    sentence: "혁신이 지도자와 추종자를 가른다.",
    author: "스티브 잡스",
  },
  {
    sentence:
      "당신이 살면서 어떤 부침을 겪든 간에 생각이 당신의 기본 자산이 되어야 한다.",
    author: "APJ칼람",
  },
  {
    sentence: "나는 내가 더 노력할수록 운이 더 좋아진다는 걸 발견했다.",
    author: "토마스 제퍼슨",
  },
  {
    sentence: "모든 성취의 시작점은 갈망이다.",
    author: "나폴레온 힐",
  },
  {
    sentence: "성공은 매일 반복한 작은 노력들의 합이다.",
    author: "로버트 콜리어",
  },
  {
    sentence:
      "뛰어난 걸 원하면 오늘 당장 이룰 수 있다. 지금 당장 뛰어나지 못한 일을 그만둬라.",
    author: "토마스 J.왓슨",
  },
  {
    sentence: "모든 진보는 익숙한 영역이 아닌 곳에서 이뤄진다.",
    author: "마이클 존 보박",
  },
  {
    sentence:
      "성공을 갈망할 때만 성공할 수 있고, 실패해도 상관없다고 생각할 때만 실패할 수 있다.",
    author: "필리포스",
  },
  {
    sentence:
      "용기는 공포에의 저항이며 공포의 극복이지만 공포심 자체를 없애는 것은 아니다.",
    author: "마크 트웨인",
  },
  {
    sentence: "마치지 않고 죽어도 되는 일만 내일로 미뤄라.",
    author: "파블로 피카소",
  },
  {
    sentence:
      "사람들은 동기 부여는 오래가지 않는다고 말한다. 목욕도 마찬가지다. 그래서 매일 하라고 하는 것이다.",
    author: "지그 지글러",
  },
  {
    sentence: "우리는 우리가 늘 생각하는 것이 된다. 그것이 가장 묘한 비밀이다.",
    author: "나이팅게일",
  },
  {
    sentence: "비밀로 남기는 선행은 가장 명예로운 일이다.",
    author: "파즈",
  },
  {
    sentence:
      "삶에 진정한 흥미가 있고 호기심이 있는 삶을 살면 잠이 가장 중요한 것이 아니게 된다는 것을 발견했다.",
    author: "미사 스튜어트",
  },
  {
    sentence:
      "당신이 눈으로 보는 것이 아니라 진짜로 발견하는 것이 무엇인가가 중요하다.",
    author: "명언",
  },
  {
    sentence: "성공으로 가는 길과 실패로 가는 길은 거의 똑같다.",
    author: "콜린 R. 데이비스",
  },
  {
    sentence:
      "리더십의 기능은 지도자를 더 많이 만드는 것이지 추종자를 더 많이 만드는 게 아니다.",
    author: "랄프 네이더",
  },
  {
    sentence:
      "성공이란 당신 자신, 당신이 하는 일, 그 일을 하는 방식을 좋아하는 것이다.",
    author: "마야 앤젤루",
  },
  {
    sentence:
      "다음 세기를 바라보는 지금, 지도자들은 다른 사람들에게 힘을 주는 사람이 될 것이다.",
    author: "빌 게이츠",
  },
  {
    sentence: "진짜 사업가는 안전망이 없는 사람이다.",
    author: "헨리 크래비스",
  },
  {
    sentence:
      "애초에 처한 상황의 포로가 되기를 거부할 때 성공으로 가는 첫발을 내디딘 것이다.",
    author: "마크케인",
  },
  {
    sentence:
      "당신이 다수의 편에 서 있다는 걸 깨닫게 될 때가 다시 생각해볼 때이다.",
    author: "마크 트웨인",
  },
  {
    sentence: "성공한 전사는 면도날 같은 초점을 지닌 평범한 사람이다.",
    author: "브루스 리",
  },
  {
    sentence: "다시 한번이라는 어리석은 말을 내게는 하지 말라.",
    author: "미라보",
  },
  {
    sentence:
      "실패에서부터 성공을 만들어 내라. 좌절과 실패는 성공으로 가는 가장 확실한 디딤돌이다.",
    author: "카네기",
  },
  {
    sentence:
      "당신이 정말로 뭔가를 원한다면 기다리지 마라. 견디지 못하는 법을 스스로 가르쳐라",
    author: "구르박쉬 차할",
  },
  {
    sentence: "패배의 공포가 승리의 짜릿함보다 커지게 하지 마라.",
    author: "로버트 키요사키",
  },
  {
    sentence:
      "영속적인 변화를 이루고 싶으면 당신의 문제의 크기에 집중하지 말고 당신의 크기에 집중하라!",
    author: "T. 하브 에커",
  },
  {
    sentence:
      "사람들이 인생에서 실패하는 가장 큰 이유는 친구, 가족, 이웃들의 말을 듣기 때문이다.",
    author: "나폴레온 힐",
  },
  {
    sentence:
      "내 경험으로 동기란 단 하나뿐이고, 그건 갈망이다. 어떤 판단이나 원칙도 그걸 누르거나 저항할 수 없다.",
    author: "제인 스마일리",
  },
  {
    sentence:
      "성공이란 절대 실수를 하지 않는 게 아니라 같은 실수를 두 번 하지 않는 것에 있다.",
    author: "조지버나드 쇼",
  },
  {
    sentence:
      "내 삶이 끝날 때 내가 내 삶의 길이만큼만 살았다는 걸 깨닫고 싶지 않다. 내 삶의 폭도 살고 싶다.",
    author: "다이앤 애커먼",
  },
  {
    sentence:
      "위대한 일들을 이루기 전에 스스로에게 위대한 일들을 기대해야 한다.",
    author: "마이클 조던",
  },
  {
    sentence:
      "동기 부여가 당신을 시작하게 한다. 습관이 당신을 계속 움직이게 한다.",
    author: "짐 륜",
  },
  {
    sentence: "과정에서 재미를 느끼지 못하는 데 성공하는 일은 거의 없다.",
    author: "카네기",
  },
  {
    sentence:
      "단호한 마음의 굳은 결심을 막거나 통제할 수 있는 우연, 운명, 숙명이란 없다.",
    author: "엘라 휠러 윌콕스",
  },
  {
    sentence:
      "만족스럽게 잠자리에 들려면 매일 아침 투지를 가지고 일어나야 한다.",
    author: "조지 로리머",
  },
  {
    sentence:
      "성공하려면 당신을 찾아오는 모든 도전을 다 받아들여야 한다. 마음에 드는 것만 골라 받을 수는 없다.",
    author: "마이크 가프카",
  },
  {
    sentence:
      "비참해져라. 혹은 스스로 동기를 부여하라. 뭘 해야 하든, 그건 언제나 당신의 선택이다.",
    author: "웨인 다이어",
  },
  {
    sentence:
      "위대한 것을 이루려면 우리는 행동할 뿐 아니라 꿈도 꾸어야 하고, 계획할 뿐 아니라 믿기도 해야 한다.",
    author: "아나톨 프랑스",
  },
  {
    sentence:
      "세상에서 가장 중요한 일들 대부분은 아무도 도와주지 않을 때도 계속 노력한 사람들에 의해 이루어졌다.",
    author: "카네기",
  },
  {
    sentence:
      "성취의 크기는 목표를 이루기 위해 당신이 극복해야 했던 장애물의 크기로 잰다.",
    author: "부커 T. 워싱턴",
  },
  {
    sentence:
      "진짜 어려움은 극복할 수 있다. 정복할 수 없는 것은 상상 속의 어려움뿐이다.",
    author: "시어도어N. 베일",
  },
  {
    sentence: "모방해서 성공하는 것보다 독창적으로 실패하는 게 더 낫다.",
    author: "허먼 멜빌",
  },
  {
    sentence: "모방에 의해서 위대하게 된 사람은 아직 한 사람도 없었다.",
    author: "사무엘 존슨",
  },
  {
    sentence:
      "독창성의 장점은 참신이 아니라, 성실이다. 믿는 사람은 독창적인 인간이다.",
    author: "토머스 칼라일",
  },
  {
    sentence: "운은 용기를 내는 사람의 편이다.",
    author: "베르길리우스",
  },
  {
    sentence:
      "대자연은 인간이 사는 거리와 멀리 떨어져 자연만이 혼자 있을 때 가장 번영한다.",
    author: "솔로",
  },
  {
    sentence:
      "소인배는 불운에 길들고 눌린다. 그러나 위대한 사람들은 불운 위로 올라선다.",
    author: "워싱턴 어빙",
  },
  {
    sentence: "실패는 성공을 맛 내는 양념이다.",
    author: "트루먼 카포티",
  },
  {
    sentence: "당신이 할 수 없는 일이 할 수 있는 일에 지장을 주게 하지 마라.",
    author: "존 R. 우든",
  },
  {
    sentence: "이기기 위해서는 한 번 이상 전쟁을 치러야 할 때도 있다.",
    author: "마가렛 대처",
  },
  {
    sentence: "삶이 있는 한 희망은 있다.",
    author: "마르쿠스 툴리우스 키케로",
  },
  {
    sentence: "산다는 것 그것은 치열한 전투이다.",
    author: "로맹 롤랑",
  },
  {
    sentence: "언제나 현재에 집중할 수 있다면 행복할 것이다.",
    author: "파울로 코엘료",
  },
  {
    sentence:
      "진정으로 웃으려면 고통을 참아야 하며, 나아가 고통을 즐길 줄 알아야 해.",
    author: "찰리 채플린",
  },
  {
    sentence:
      "직업에서 행복을 찾아라. 아니면 행복이 무엇인지 절대 모를 것이다.",
    author: "엘버트 허버드",
  },
  {
    sentence: "신은 용기 있는 자를 결코 버리지 않는다.",
    author: "헬렌 켈러",
  },
  {
    sentence: "오랫동안 꿈을 그리는 사람은 마침내 그 꿈을 닮아 간다.",
    author: "앙드레 말로",
  },
  {
    sentence:
      "좋은 성과를 얻으려면 한 걸음 한 걸음이 힘차고 충실하지 않으면 안 된다.",
    author: "단테",
  },
  {
    sentence: "오직 남들을 위하여 산 인생만이 가치 있는 것이다.",
    author: "아인슈타인",
  },
  {
    sentence: "울지 않는 청년은 야만인이요 웃지 않는 노인은 바보다.",
    author: "조지 산타아나",
  },
  {
    sentence: "사랑은 고생을 면할 수가 없다. 그러나 잊을 수 있는 능력이 있다.",
    author: "벤저민 디즈레일리",
  },
  {
    sentence: "사람을 알려면 그의 지갑, 쾌락, 그리고 불평을 보라.",
    author: "탈무드",
  },
  {
    sentence: "최고급 회개란 과거의 죄를 청산하고 똑바로 행동하는 것이다.",
    author: "윌리엄 제임스",
  },
  {
    sentence: "생활의 기술이란 우리의 환경에 대한 계속된 적응을 의미한다.",
    author: "오카쿠라 카쿠조",
  },
  {
    sentence:
      "은혜를 입은 자는 잊지 말아야 하고 베푼 자는 기억하지 말아야 한다.",
    author: "피레 찰론",
  },
  {
    sentence: "현대화보다 더 고상한 것이 있다. 그것은 바로 영원한 것이다.",
    author: "솔로몬 세치터",
  },
  {
    sentence: "당신은 항상 영웅이 될 수 없다. 그러나 항상 사람은 될 수 있다.",
    author: "요한 볼프강 폰 괴테",
  },
  {
    sentence: "당신은 바로 자기 자신의 창조자이다.",
    author: "카네기",
  },
  {
    sentence: "어떤 가치 있는 행동을 하지 아니한 날, 그날은 잃은 날이다.",
    author: "자콥 보바트",
  },
  {
    sentence:
      "좋은 일을 많이 해내려고 기다리는 사람은 하나의 좋은 일도 해낼 수가 없다.",
    author: "사무엘 존슨",
  },
  {
    sentence: "소비된 시간은 존재하고 이용된 시간은 생명이다.",
    author: "영",
  },
  {
    sentence: "내일의 모든 꽃은 오늘의 씨앗에 근거한 것이다.",
    author: "속담",
  },
  {
    sentence:
      "내일의 현실에 대한 유일한 제한은 오늘의 의구심이다. 강하고 적극적인 신념을 가지고 앞으로 나아가자.",
    author: "프랭클린 델러노 루스벨트",
  },
  {
    sentence: "죄는 취소될 수 없다. 용서될 뿐이다.",
    author: "스트라빈스키",
  },
  {
    sentence: "자유는 획득하는 것보다 간직하는 것이 더 어렵다.",
    author: "컬훈",
  },
  {
    sentence: "참된 삶을 맛보지 못한 자만이 죽음을 두려워하는 것이다.",
    author: "제이 메이",
  },
  {
    sentence:
      "가치 있는 적이 될 수 있는 자는 화해하면 더 가치 있는 친구가 될 것이다.",
    author: "펠담",
  },
  {
    sentence: "원인은 숨겨지지만, 결과는 잘 알려진다.",
    author: "오비딩스",
  },
  {
    sentence: "게으름은 쇠붙이의 녹과 같다. 노동보다도 더 심신을 소모시킨다.",
    author: "프랭클린",
  },
  {
    sentence: "겨울은 하늘의 물도, 사람의 마음도 돌처럼 만들어 버린다.",
    author: "빅토르 마리 위고",
  },
  {
    sentence: "격에 맞지 않는 선행은 악행이라고 나는 생각한다.",
    author: "엔니우스",
  },
  {
    sentence: "하늘에는 입이 없으므로, 사람이 하여금 말하게 한다.",
    author: "하이케이야기",
  },
  {
    sentence: "민주주의는 정지된 것이 아니라 영원히 계속되는 행진이다.",
    author: "루즈벨트",
  },
  {
    sentence: "금전은 무자비한 주인이지만 유익한 종이 되기도 한다.",
    author: "유태 격언",
  },
  {
    sentence: "힘없는 정부는 미약하고, 정의 없는 힘은 포악이다.",
    author: "파스칼",
  },
  {
    sentence: "기회는 새와 같은 것, 날아가기 전에 꼭 잡아라.",
    author: "스마일즈",
  },
  {
    sentence: "맹세는 말에 지나지 않고 말은 바람에 지나지 않는다.",
    author: "버틀러",
  },
  {
    sentence: "늑대는 이빨을 잃어도 그 천성은 잃지 않는다.",
    author: "풀러",
  },
  {
    sentence: "언론의 자유를 죽이는 것은 진리를 죽이는 것이다.",
    author: "존 밀턴",
  },
  {
    sentence: "성공의 비결은 목적을 향해 시종일관하는 것이다.",
    author: "벤자민 디즈레일리",
  },
  {
    sentence: "의인의 수고는 생명에 이르고 악인의 소득은 죄에 이른다.",
    author: "성경",
  },
  {
    sentence: "가장 높은 곳에 올라가려면, 가장 낮은 곳부터 시작하라.",
    author: "푸블릴리우스 시루스",
  },
  {
    sentence: "가장 뛰어난 예언자는 과거이다.",
    author: "바이런",
  },
  {
    sentence: "가장 무서운 사람은 침묵을 지키는 사람이다.",
    author: "호라티우스",
  },
  {
    sentence: "가시에 찔리지 않고서는 장미꽃을 모을 수가 없다.",
    author: "필페이",
  },
  {
    sentence: "가장 부유한 사람은 절약가이고 가장 가난한 사람은 수전노이다.",
    author: "상포르",
  },
  {
    sentence: "가장 오래 지속되는 사랑은 다시는 돌아오지 않는 사랑이다.",
    author: "윌리엄 서미싯 몸",
  },
  {
    sentence: "청년이여 일하라. 좀 더 일하라. 끝까지 열심히 일하라.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence: "한가한 인간은 고여있는 물이 썩는 것과도 같다.",
    author: "격언",
  },
  {
    sentence: "빈곤은 재앙이 아니라 불편이다.",
    author: "플로리오",
  },
  {
    sentence: "살아 있는 실패작은 죽은 걸작보다 낫다.",
    author: "버나드 쇼",
  },
  {
    sentence: "정직은 가장 확실한 자본이다.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence:
      "모든 일은 계획으로 시작하고, 노력으로 성취되며, 오만으로 망친다.",
    author: "관자(管子)",
  },
  {
    sentence: "태만을 즐기고 있을 때는 태만함을 느끼지 못한다.",
    author: "가스가 센안",
  },
  {
    sentence: "사업을 좌우하여라. 사업에 의해 좌우되어서는 안 된다.",
    author: "프랭클린",
  },
  {
    sentence: "백 년을 살 것처럼 일하고 내일 죽을 것처럼 기도하라.",
    author: "프랭클린",
  },
  {
    sentence: "부유함이 문명을 낳지는 못하나, 문명은 부유함을 낳는다.",
    author: "비처",
  },
  {
    sentence: "가난한 사람은 덕행으로, 부자는 선행으로 이름을 떨쳐야 한다.",
    author: "주베르",
  },
  {
    sentence: "가르치는 것은 두 번 배우는 것이다.",
    author: "주베르",
  },
  {
    sentence: "가장 감사해야 할 것은 신이 주신 능력을 제대로 이용하는 것이다.",
    author: "트릴로프",
  },
  {
    sentence: "가시나무를 심는 자는 장미를 기대해서는 안된다.",
    author: "필페이",
  },
  {
    sentence: "가는 자는 쫓지 말지며, 오는 자는 막지 말라.",
    author: "맹자(孟子)",
  },
  {
    sentence: "시종일관하는 자는 운명을 믿고, 변덕 부리는 자는 요행을 믿는다.",
    author: "벤자민 디즈레일리",
  },
  {
    sentence: "인간의 진정한 재산은 그가 이 세상에서 행하는 선행이다.",
    author: "마호메트",
  },
  {
    sentence:
      "자신이 현명하다고 생각하고 있는 인간은 정녕 구제할 수 없는 바보이다.",
    author: "볼테르",
  },
  {
    sentence: "얻기 어려운 것은 시기요, 놓치기 쉬운 것은 기회이다.",
    author: "조광조",
  },
  {
    sentence:
      "누구나 오래 살기를 바란다. 그러나 누구를 막론하고 나이는 먹기 싫어한다.",
    author: "스위프트",
  },
  {
    sentence: "술은 인격을 비춰주는 거울이다.",
    author: "아르케시우스",
  },
  {
    sentence: "충실한 삶의 깊이를 아는 자는 아름다운 죽음의 가치를 안다.",
    author: "테오도르",
  },
  {
    sentence:
      "가장 훌륭한 기술, 가장 배우기 어려운 기술은 세상을 살아가는 기술이다.",
    author: "메이시",
  },
  {
    sentence: "여가를 활용하지 못하는 사람은 항상 여가 시간이 없다.",
    author: "격언",
  },
  {
    sentence:
      "가장 최상의 길은 없다. 많은 사람이 가고 있다면 그 길이 최상이다.",
    author: "루신",
  },
  {
    sentence: "가장 훌륭한 예언은 상식, 즉 우리의 원래의 지혜이다.",
    author: "에우리피데스",
  },
  {
    sentence:
      "많은 불행은 난처한 일과 말하지 않은 채로 남겨진 일 때문에 생겼다.",
    author: "도스토예프스키",
  },
  {
    sentence:
      "가정과 가정 생활의 안전과 향상이 문명의 중요 목적이요, 산업의 궁극적 목적이다.",
    author: "C.W.엘리어",
  },
  {
    sentence: "가장 탁월한 천분도 무위도식에 의해서 멸망된다.",
    author: "몽테뉴",
  },
  {
    sentence: "가정이여, 그대는 도덕의 학교이다.",
    author: "J.H.페스탈로치",
  },
  {
    sentence:
      "가정은 그대가 그곳에 가야만 할 때, 그들이 받아들여야 하는 곳이다.",
    author: "R.L.프로스트",
  },
  {
    sentence:
      "가정은 나의 대지이다. 나는 거기서 나의 정신적인 영양을 섭취하고 있다.",
    author: "펄 벅",
  },
  {
    sentence: "대지는 인간이 살아가기 위한 보고다.",
    author: "토마스 제퍼슨",
  },
  {
    sentence: "가정은 사람이 '있는 그대로'의 자기를 표시할 수 있는 장소이다.",
    author: "A.모루아",
  },
  {
    sentence: "가정은 삶의 보물상자가 되어야 한다.",
    author: "코르뷔제",
  },
  {
    sentence: "강을 거슬러 헤엄치는 자가 강물의 세기를 안다.",
    author: "윌슨",
  },
  {
    sentence: "갑작스럽게 착한 사람이 되거나 악인이 되는 사람은 없다.",
    author: "시드니",
  },
  {
    sentence: "강렬한 욕망을 버리고 싶거든 그 어머니인 낭비를 버려라.",
    author: "마르쿠스 툴리우스 키케로",
  },
  {
    sentence:
      "강도는 당신의 돈이나 생명의 어느 하나를 요구한다. 그러나 여자는 그 양쪽을 요구한다.",
    author: "버클러",
  },
  {
    sentence:
      "가치있는 적이 될 수 있는 자는 화해하면 더 가치있는 친구가 될 것이다.",
    author: "펠담",
  },
  {
    sentence: "가정이란 어떠한 형태의 것이든 인생의 커다란 목표이다.",
    author: "J.G.홀랜드",
  },
  {
    sentence: "죽음을 두려워하는 나머지 삶을 시작조차 못 하는 사람이 많다.",
    author: "벤다이크",
  },
  {
    sentence: "신념은 연애와 같은 것이어서 강요할 수 없는 것이다.",
    author: "쇼펜하우어",
  },
  {
    sentence: "속이는 말로 재물을 모으는 것은 죽음을 구하는 것이다.",
    author: "성경",
  },
  {
    sentence: "말이 입힌 상처는 칼이 입힌 상처보다 깊다.",
    author: "격언",
  },
  {
    sentence: "이해가 부족한 사람이 오해가 많은 사람보다 낫다.",
    author: "아나톨 프랑스",
  },
  {
    sentence: "한 시대의 철학은 다음 시대에서는 평범한 상식에 불과하다.",
    author: "헨리 W. 비치",
  },
  {
    sentence: "결함이 나의 출발의 바탕이고 무능이 나의 근원이다.",
    author: "발레리",
  },
  {
    sentence: "현실에 대한 눈은 감을 수 있어도 기억에 대한 눈은 감을 수 없다.",
    author: "스타니스러우 J. 룩",
  },
  {
    sentence: "생각이 깊지 못한 사람은 항상 입을 놀린다.",
    author: "호머",
  },
  {
    sentence: "부지런한 바보만큼 이웃을 괴롭히는 자는 없다.",
    author: "가이야",
  },
  {
    sentence: "무지함을 두려워 말라. 거짓 지식을 두려워하라.",
    author: "파스칼",
  },
  {
    sentence: "말하는 것은 지식의 영역이고 듣는 것은 지혜의 특권이다.",
    author: "올리버 웬들 홈스",
  },
  {
    sentence: "자신의 행동이 빗나간 사람일수록 맨 먼저 남을 모략한다.",
    author: "몰리에르",
  },
  {
    sentence: "인간이란 생각하는 것이 적으면 적을수록 많이 지껄여댄다.",
    author: "몽테스키외",
  },
  {
    sentence: "남은 많이 용서하되 자신은 결코 용서하지 말라.",
    author: "푸블릴리우스 시루스",
  },
  {
    sentence:
      "남을 아는 사람은 지혜있는 자이지만 자기를 아는 사람이 더욱 명찰한 자이다.",
    author: "노자(老子)",
  },
  {
    sentence:
      "남을 이기는 사람은 힘이 있는 자이지만 자기 스스로를 이기는 사람은 더욱 강한 사람이다.",
    author: "노자(老子)",
  },
  {
    sentence:
      "남을 정면으로 비난하는 것은 좋지 않다. 그를 망신시키기 때문이다.",
    author: "레프 니콜라예비치 톨스토이",
  },
  {
    sentence:
      "보이지 않는 곳에서 비난하는 것은 불성실하다. 덕을 기만하는 것이 되기 때문이다.",
    author: "레프 니콜라예비치 톨스토이",
  },
  {
    sentence: "남의 위험에서 자신에게 이익이 되는 교훈을 끌어내라.",
    author: "푸블리우스 아페르 테렌티우스",
  },
  {
    sentence: "남자가 야생동물이면 여자는 이 야생동물을 길들이는 자이다.",
    author: "폴리스 바이언",
  },
  {
    sentence:
      "남자끼리는 원래 서로가 무관심한 것이지만 여자란 태어나면서부터 적이다.",
    author: "쇼펜하우어",
  },
  {
    sentence: "사람은 자기 일 보다 남의 일을 더 잘 알고 더 잘 판단한다.",
    author: "테렌티우스",
  },
  {
    sentence: "눈을 감아라. 그럼 너는 너 자신을 볼 수 있으리라.",
    author: "버틀러",
  },
  {
    sentence: "군자는 의리에 밝고, 소인은 이익에 밝다.",
    author: "공자(孔子)",
  },
  {
    sentence:
      "눈물을 흘리면서 빵을 먹어보지 못한 사람은 인생의 참맛을 알 수 없다.",
    author: "요한 볼프강 폰 괴테",
  },
  {
    sentence: "굳은 결심은 가장 유용한 지식이다.",
    author: "보나파르트 나폴레옹",
  },
  {
    sentence: "굴욕적인 신앙보다는 숫제 무신앙인 편이 좋다.",
    author: "베이컨",
  },
  {
    sentence:
      "굶주림이 혁명을 낳는 것은 아니다. 그보다도 민중이 먹게 되자 식욕을 얻은 것이다.",
    author: "프리드리히 빌헬름 니체",
  },
  {
    sentence: "권리는 어느 곳에나 도리를 벗어난 곳에서는 존재할 수 없다.",
    author: "파크",
  },
  {
    sentence: "선을 행하는 데는 나중이라는 말이 필요 없다.",
    author: "요한 볼프강 폰 괴테",
  },
  {
    sentence: "학문의 최대의 적은 자기 마음속에 있는 유혹이다.",
    author: "처칠",
  },
  {
    sentence: "기대하지 않는 자는 실망하지도 않을 것이다.",
    author: "울거트",
  },
  {
    sentence: "기둥이 약하면 집이 흔들리듯, 의지가 약하면 생활도 흔들린다.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence: "기와 한장 아껴서 대들보 썩는다.",
    author: "속담",
  },
  {
    sentence: "좋은 밤을 찾다가 좋은 낮을 잃어버리는 사람들이 많다.",
    author: "격언",
  },
  {
    sentence:
      "악은 쾌락 속에서도 고통을 주지만 덕은 고통 속에서도 위안을 준다.",
    author: "콜튼",
  },
  {
    sentence: "환락은 망상 위에 세울 수 있으나, 행복은 진리 위에만 세워진다.",
    author: "니꼬라",
  },
  {
    sentence: "많은 벗을 가진 사람은 한 사람의 진실한 벗을 가질 수 없다.",
    author: "아리스토텔레스",
  },
  {
    sentence: "지성인은 자기의 마음으로 자기 자신을 망보는 사람이다.",
    author: "까뮈",
  },
  {
    sentence: "어떠한 충고일지라도 길게 말하지 말라.",
    author: "호라티우스",
  },
  {
    sentence: "남자는 마음으로 늙고 여자는 얼굴로 늙는다.",
    author: "속담",
  },
  {
    sentence:
      "남자는 인생을 지나치게 빨리 깨닫고, 여자는 인생을 너무나 늦게 알게 된다.",
    author: "와일드",
  },
  {
    sentence: "남자의 마음은 대리석과 같고 여자의 마음은 밀림과 같다.",
    author: "셰익스피어",
  },
  {
    sentence:
      "누구 한 사람 아는 이 없는 곳에서 사는 것은 즐거운 일이기도 하다.",
    author: "헤르만 헤세",
  },
  {
    sentence:
      "내가 가장 사랑하는 덕이 있다. 단 하나, 그 이름은 '자유'라고 한다.",
    author: "헤르만 헤세",
  },
  {
    sentence: "친구를 얻는 유일한 방법은 스스로 완전한 친구가 되는 것이다.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence: "지식과 목재는 세파에 시달리지 아니하면 많이 애용될 수가 없다.",
    author: "올리버 웬델 홈즈",
  },
  {
    sentence:
      "거룩하고 즐겁고 활기차게 살아라. 믿음과 열심에는 피곤과 짜증이 없다.",
    author: "어니스트 핸즈",
  },
  {
    sentence: "아무리 화려한 궁전이라도 초라한 내 집만 한 곳은 없다.",
    author: "페인",
  },
  {
    sentence: "하나의 모범은 천 마디의 논쟁보다 더 가치 있는 것이다.",
    author: "토마스 카알라일",
  },
  {
    sentence: "당신은 의지의 주인이 되라. 그리고 당신은 양심의 노예가 되라.",
    author: "유태 격언",
  },
  {
    sentence: "작은 도끼라도 찍고 찍으면 큰 참나무는 넘어진다.",
    author: "셰익스피어",
  },
  {
    sentence: "행동을 초래시키지 않는 생각, 그것은 생각이 아니라 공상이다.",
    author: "엘리자 램브 마틴",
  },
  {
    sentence:
      "민주주의의 모든 질병은 더 많은 민주주의에 의해서 치료될 수 있다.",
    author: "알프레드 스미스",
  },
  {
    sentence: "용기가 없는 사람에게는 어떤 좋은 것도 생기지 않는다.",
    author: "마르쿠스 아우렐리우스",
  },
  {
    sentence: "오직 바보나 죽은 자만이 절대로 자기의 의견을 변화시키지 않는다.",
    author: "제임스 럿셀 로우웰",
  },
  {
    sentence: "큰 시련은 큰 의무를 완수하게 만드는 것이다.",
    author: "톰슨",
  },
  {
    sentence: "배운 사람은 항상 자기 속에 재산이 있다.",
    author: "필래드라스",
  },
  {
    sentence: "적당주의자가 되지 말라. 그것은 세상에서 가장 위험한 것이다.",
    author: "휴그 왈폴",
  },
  {
    sentence: "자연은 하나님의 작품이요. 예술은 사람의 작품이다.",
    author: "롱펠로우",
  },
  {
    sentence: "편견이란 실효성이 없는 의견이다.",
    author: "암브로스 빌",
  },
  {
    sentence: "선한 사람이 되라. 그러면 세상은 선한 세상이 될 것이다.",
    author: "흰두교 격언",
  },
  {
    sentence:
      "인류를 위해 사는 것은 자기의 이름을 위해 사는 것보다 훌륭한 것이다.",
    author: "바첼 린드세이",
  },
  {
    sentence: "작지만 청결한 것은 큰 것이요. 크지만 불결한 것은 작은 것이다.",
    author: "바이",
  },
  {
    sentence: "기쁨을 주는 사람만이 더 많은 기쁨을 즐길 수 있다.",
    author: "알렉산더 듀마",
  },
  {
    sentence: "너 자신을 다스려라. 그러면 당신은 세계를 다스릴 것이다.",
    author: "속담",
  },
  {
    sentence: "작은 구멍 하나가 큰 배를 침몰시키는 것이다.",
    author: "에프라임 도마라츠키",
  },
  {
    sentence: "성실하지 못한 사람은 위대한 것들을 생산할 수가 없다.",
    author: "제임스 러셀 로웰",
  },
  {
    sentence: "목표를 보는 자는 장애물을 겁내지 않는다.",
    author: "한나 모어",
  },
  {
    sentence: "너 자신을 알라.",
    author: "소크라테스",
  },
  {
    sentence: "산을 옮기는 사람은 작은 돌멩이부터 옮긴다.",
    author: "속담",
  },
  {
    sentence: "세상이 당신에게 준 것보다 더 많이 세상에게 주라.",
    author: "헨리 포드",
  },
  {
    sentence: "험담은 세 사람을 죽인다. 말하는 자, 험담의 대상자, 듣는 자.",
    author: "미드라쉬",
  },
  {
    sentence: "핑계를 잘 대는 사람은 거의 좋은 일을 하나도 해내지 못한다.",
    author: "벤자민 프랭클린",
  },
  {
    sentence:
      "겸손이 없다면 당신은 인생의 가장 기본적인 교훈도 배울 수가 없다.",
    author: "존 톰슨",
  },
  {
    sentence:
      "너 자신을 아는 것을 너의 일로 삼으라. 그것은 세상에서 가장 어려운 교훈이다.",
    author: "미겔 더 사아베드라 세르반테스",
  },
  {
    sentence: "작은 성공을 만족스럽게 생각하는 사람은 큰 성공을 얻지 못한다.",
    author: "제세 메서 게만",
  },
  {
    sentence: "나는 내 운명의 주인이요, 나는 내 마음의 선장이다.",
    author: "윌리암 어네스트 헨리",
  },
  {
    sentence: "존재하는 것을 변화시키는 것은 성숙하게 만드는 것이다.",
    author: "헨리 버그슨",
  },
  {
    sentence: "인격은 당신의 아이들에게 남겨줄 수 있는 최대의 유산이다.",
    author: "아놀드 그라소우",
  },
  {
    sentence:
      "과도한 재산을 소유하게 되었을 때보다 더 시련을 당하게 되는 적은 없다.",
    author: "레우왈레이스",
  },
  {
    sentence:
      "관습은 법만큼 현명하지 못할지 모른다. 그러나 관습은 언제나 법보다 훨씬 보편적이다.",
    author: "벤자민 디즈레일리",
  },
  {
    sentence: "괴로움을 견디려면 죽는 것보다 더 큰 용기가 필요하다.",
    author: "보나파르트 나폴레옹",
  },
  {
    sentence:
      "교사의 임무는 독창적인 표현과 지식의 희열을 불러 일으켜주는 일이다.",
    author: "알베르트 아인슈타인",
  },
  {
    sentence:
      "내가 소라고 말하면 그것은 소가 되고, 내가 말이라고 하면 그것은 말이 된다.",
    author: "장자(莊子)",
  },
  {
    sentence: "행동가처럼 생각하라. 그리고 생각하는 사람처럼 행동하라.",
    author: "헨리 버그슨",
  },
  {
    sentence:
      "소유물의 부족은 개선할 수 있으나 영혼의 가난은 해결하기 쉬운 것이 아니다.",
    author: "몽테뉴",
  },
  {
    sentence: "당신의 인생은 당신이 하루 종일 무슨 생각을 하는지에 달려있다.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence: "하나님 앞에서는 울어라. 그러나 사람들 앞에서는 웃어라.",
    author: "유태 격언",
  },
  {
    sentence: "인내하라. 경험하라. 조심하라. 그리고 희망을 품어라.",
    author: "조셉 에디슨",
  },
  {
    sentence: "위대한 사람은 절대로 기회가 부족하다고 불평하지 않는다.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence: "위대한 사람은 목적을, 소인들은 공상을 가지고 있다.",
    author: "와싱턴 어빙",
  },
  {
    sentence: "사람의 척도는 그가 불행을 얼마나 잘 이겨내는지에 달려있다.",
    author: "프르다크",
  },
  {
    sentence: "돈으로 살 수 있는 행복이라 불리는 상품은 없다.",
    author: "헨리 벤 타이크",
  },
  {
    sentence: "세상에서 가장 아름다운 것은 세상 그 자체이다.",
    author: "스티븐슨",
  },
  {
    sentence:
      "일은 인간생활의 피할 수 없는 조건이며, 인간 복지의 참된 근원이다.",
    author: "톨스토이",
  },
  {
    sentence: "좋은 전쟁 또는 나쁜 평화는 없다.",
    author: "벤자민 프랭클린",
  },
  {
    sentence:
      "일은 인류를 사로잡는 모든 질환과 비참을 치료해 주는 주요한 치료제이다.",
    author: "칼라일",
  },
  {
    sentence: "최대다수의 최대행복은 도덕과 입법의 초석이다.",
    author: "벤담",
  },
  {
    sentence:
      "전쟁에선 어느 편이 스스로를 승자라고 부를지라도 승리자는 없고 모두 패배자뿐이다.",
    author: "챔벌린",
  },
  {
    sentence: "전쟁에서는 오직 한 번 죽지만 정치에서는 여러 번 죽는다.",
    author: "윈스턴 처칠",
  },
  {
    sentence: "일을 몰고 가라. 그렇지 않으면 일이 너를 몰고 갈 것이다.",
    author: "벤자민 프랭클린",
  },
  {
    sentence: "위대한 것 치고 정열이 없이 이루어진 것은 없다.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence: "인생을 해롭게 하는 비애를 버리고 명랑한 기질을 간직하라.",
    author: "셰익스피어",
  },
  {
    sentence:
      "우유부단한 것만이 습관으로 되어 있는 사람보다 더 비참한 사람은 없다.",
    author: "제임스",
  },
  {
    sentence: "인간은 아직까지도 모든 컴퓨터 중에서 가장 훌륭한 컴퓨터이다.",
    author: "케네디",
  },
  {
    sentence: "우리의 거의 모든 삶이 어리석은 호기심에 낭비되고 있다.",
    author: "보들레르",
  },
  {
    sentence: "조용한 물이 깊이 흐른다.",
    author: "릴리",
  },
  {
    sentence:
      "다른 사람들을 비난하려고 생각하기 전에 자기 자신을 충분히 살펴보아야 한다.",
    author: "몰리에르",
  },
  {
    sentence: "천재란 인내에 대한 위대한 자질 이외에는 아무것도 아니다.",
    author: "뷰퐁",
  },
  {
    sentence: "시간을 선택하는 것은 시간을 절약하는 것이다.",
    author: "베이컨",
  },
  {
    sentence:
      "친구들을 불신한다는 것은 그들에게 속은 것보다 더 수치스러운 일이다.",
    author: "로셔푸코",
  },
  {
    sentence: "맹세는 말에 지나지 않고, 말은 바람에 지나지 않는다.",
    author: "버틀러",
  },
  {
    sentence:
      "어리석은 자는 수치스러운 일을 할 때도 그것이 언제나 그의 의무라고 선포한다.",
    author: "버나드 쇼",
  },
  {
    sentence: "시간을 잘 맞춘 침묵은 말보다 더 좋은 웅변이다.",
    author: "터퍼",
  },
  {
    sentence:
      "청년기는 대실수이다. 장년기는 투쟁이다. 그리고 노년기는 후회이다.",
    author: "디즈레일리",
  },
  {
    sentence: "절제는 모든 미덕의 진주 고리를 이어주는 비단의 실이다.",
    author: "홀",
  },
  {
    sentence:
      "삶은 순간들의 연속이다. 한순간, 한순간을 사는 것이 성공하는 것이다.",
    author: "켄트",
  },
  {
    sentence: "우리의 인내가 우리의 힘보다 더 많은 것을 성취할 것이다.",
    author: "버크",
  },
  {
    sentence:
      "인간은 패배하였을 때 끝나는 것이 아니다. 포기했을 때 끝나는 것이다.",
    author: "닉슨",
  },
  {
    sentence:
      "어느 사회에서나 유아들에게 우유를 먹이는 것보다 더 좋은 투자는 없다.",
    author: "윈스턴 처칠",
  },
  {
    sentence: "좋은 친구는 건강에도 좋다.",
    author: "시라손",
  },
  {
    sentence: "힘으로서 사람을 복종시키지 말고 덕으로서 사람을 복종시켜라.",
    author: "맹자(孟子)",
  },
  {
    sentence:
      "군자의 사귐은 담담함이 물과 같고, 소인의 사귐은 달콤함이 단술과 같다.",
    author: "장자(莊子)",
  },
  {
    sentence: "악은 선을 인식시키고 고통은 기쁨을 느끼게 한다.",
    author: "성경",
  },
  {
    sentence: "잔잔한 바다에서는 좋은 뱃사공이 만들어지지 않는다.",
    author: "속담",
  },
  {
    sentence: "확실한 벗은 불확실한 처지에 있을 때 알려진다.",
    author: "시세로",
  },
  {
    sentence:
      "사랑은 사람들을 치료한다. 사랑을 받는 사람, 사랑을 주는 사람 할 것이 없이.",
    author: "메닝거",
  },
  {
    sentence:
      "말로 하는 사랑은 쉽게 외면할 수 있으나 행동으로 보여주는 사랑은 저항할 수가 없다.",
    author: "무니햄",
  },
  {
    sentence: "성공적인 결혼이란 매일같이 개축해야 하는 건물과 같은 것이다.",
    author: "모로아",
  },
  {
    sentence: "결혼은 자손 만대의 시작이다.",
    author: "명심보감 (明心寶鑑)",
  },
  {
    sentence:
      "결혼이란, 독립은 동등하고 의존은 상호적이며, 의무는 상반되는 남녀간의 관계이다.",
    author: "L.K.안스파",
  },
  {
    sentence: "결혼이란 하늘에서 맺어지고 땅에서 완성된다.",
    author: "존 릴리",
  },
  {
    sentence: "결혼 전에는 눈을 크게 뜨고, 결혼 후에는 반쯤 감아라.",
    author: "프랭클린",
  },
  {
    sentence:
      "결혼 전에는 두 눈을 커다랗게 뜨고 보라. 결혼 후에는 한쪽 눈을 감으라.",
    author: "토머스 풀러",
  },
  {
    sentence:
      "결혼하는 편이 좋은가, 하지 않는 편이 좋은가를 묻는다면 나는 어느 편이나 후회할 것이라고 대답하겠다.",
    author: "소크라테스",
  },
  {
    sentence: "사랑하고 나서 잃는 것은 전혀 사랑하지 않았던 것보다 더 낫다.",
    author: "테니슨",
  },
  {
    sentence: "소인은 특별한 것에 관심이 있고, 위인은 평범한 것에 관심이 있다.",
    author: "허버트",
  },
  {
    sentence: "용기는 대단히 중요하다. 근육과 같이 사용함으로써 강해진다.",
    author: "고든",
  },
  {
    sentence: "사랑하고 사랑받는 것은 태양을 양쪽에서 쪼이는 것과 같다.",
    author: "비스코트",
  },
  {
    sentence: "지성이란 그것을 갖고 있지 않는 사람에게는 보이지 않는다.",
    author: "쇼펜하우어",
  },
  {
    sentence: "분노는 바보들의 가슴속에서만 살아간다.",
    author: "아인슈타인",
  },
  {
    sentence: "너의 의무를 다하라. 그리고 나머지는 하나님께 맡겨라.",
    author: "코네일",
  },
  {
    sentence: "나의 음악은 어린아이들과 동물들이 가장 잘 이해한다.",
    author: "스트라빈스키",
  },
  {
    sentence:
      "당신이 누군가를 배반한다면, 당신은 또한 당신 자신을 배반하는 셈이다.",
    author: "싱거",
  },
  {
    sentence: "가정은 삶의 보물 상자가 되어야 한다.",
    author: "코르뷔제",
  },
  {
    sentence:
      "지식인은 지금까지 일어났던 일을 안다. 천재는 앞으로 일어날 일을 안다.",
    author: "치아디",
  },
  {
    sentence:
      "서툰 의사는 한 번에 한 사람을 해치지만, 서툰 교사는 130명을 해친다.",
    author: "보이어",
  },
  {
    sentence: "태만이란 약한 마음을 가진 사람의 유일한 피난처이다.",
    author: "스터필드",
  },
  {
    sentence:
      "권세가 인간을 교만으로 이끌어갈 때, 시가 그에게 한계를 상기시켜준다.",
    author: "케네디",
  },
  {
    sentence: "그날의 일은 그날 해치우는 것이 나의 일상규칙이다.",
    author: "웨링턴",
  },
  {
    sentence: "그래도 지구는 돈다.",
    author: "갈릴레오 갈릴레이",
  },
  {
    sentence:
      "돈은 진정 중요한 것이다. 따라서 건전하고 성공적인 개인과 국가의 도덕은 이 사실에 기초를 두어야 한다.",
    author: "조지 버나드 쇼",
  },
  {
    sentence: "그릇이 차면 넘치고, 사람이 자만하면 이지러진다.",
    author: "명심보감(明心寶鑑)",
  },
  {
    sentence: "그 어떤 강제에 의해서 우리들은 결코 행복하게 될 수는 없다.",
    author: "콜르리지",
  },
  {
    sentence: "근로가 잠들면 빈곤은 창으로 들어온다.",
    author: "라이닉",
  },
  {
    sentence: "근면이야말로 태만, 불성실, 빈곤의 세가지 부끄러움을 쫓아줍니다.",
    author: "볼테일",
  },
  {
    sentence: "무거운 마음을 가지고 가벼운 시를 즐길 수 없다.",
    author: "베이커",
  },
  {
    sentence:
      "사악은 언제나 미덕보다 더 쉽다. 왜냐하면 사악은 모든 일에 지름길을 택하기 때문이다.",
    author: "존스",
  },
  {
    sentence:
      "훌륭한 삶에는 세 가지 요소가 있다. 즉 배우는 일, 돈 버는 일, 무엇인가 하고 싶은 일.",
    author: "크리스토퍼 달링턴 몰리",
  },
  {
    sentence:
      "패배를 극복하는 법을 배워야 한다. 그럴 때에 당신의 인격이 향상된다.",
    author: "닉슨",
  },
  {
    sentence:
      "당신의 정신을 위대한 사상으로 기르라. 영웅을 믿는 일이 영웅을 만들어 낸다.",
    author: "밴자민 디즈렐리",
  },
  {
    sentence: "호기심이란 무지의 고백인데 그것은 의도적이며 당당하며 열렬하다.",
    author: "류빈슈타인",
  },
  {
    sentence:
      "여행이란 젊은이들에게는 교육의 일부이며 연장자들에겐 경험의 일부이다.",
    author: "베이컨",
  },
  {
    sentence:
      "당신의 정열을 지배하라. 그러지 않으면 정열이 당신을 지배할 것이다.",
    author: "호라티우스",
  },
  {
    sentence: "덕이 없는 아름다움은 향기 없는 꽃이다.",
    author: "격언",
  },
  {
    sentence: "무관심 때문에 사람은 실제로 죽기 전에 죽어버린다.",
    author: "위젤",
  },
  {
    sentence: "긍지는 인간이 입을 수 있는 가장 훌륭한 갑옷이다.",
    author: "제롬",
  },
  {
    sentence:
      "기고만장하게 행동하느니보다 허리를 굽히는 것이 슬기로움에 더 가깝다.",
    author: "윌리엄 워즈워스",
  },
  {
    sentence: "신기한 말을 하는 것이 귀함이 아니라 실행함이 귀하다.",
    author: "이태백",
  },
  {
    sentence: "의복에만 마음이 쏠리는 것은 마음과 인격이 잠든 탓이다.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence: "누구든지 크나큰 시련을 당하기 전에는 참다운 인간이 못 된다.",
    author: "레오랄지이",
  },
  {
    sentence: "위대한 사람은 모두가 겸손하다.",
    author: "레싱",
  },
  {
    sentence:
      "겸손은 남의 칭찬을 싫어하는 듯이 보이지만 사실은 좀더 넌즈시 칭찬받고 싶다는 욕망에 불과하다.",
    author: "라 로시푸코",
  },
  {
    sentence: "겸손은 모든 미덕의 근본이다.",
    author: "P.J.베일리",
  },
  {
    sentence:
      "겸손은 범인에게는 한갓 성실이지만, 위대한 재능의 소유자인 사람에게는 위선이다.",
    author: "셰익스피어",
  },
  {
    sentence: "겸손은 신이 우리에게 제물을 바치기 바라는 제단이다.",
    author: "라 로시푸코",
  },
  {
    sentence: "겸손은 신이 인간에게 내린 최고의 덕이다.",
    author: "브하그완",
  },
  {
    sentence: "겸손은 육체의 양심이다.",
    author: "H.발자크",
  },
  {
    sentence: "경험은 지식의 어머니이다.",
    author: "브레튼",
  },
  {
    sentence: "경험은 최고의 교사이다. 다만 수업료가 지나치게 비싸다고 할까.",
    author: "칼라일",
  },
  {
    sentence: "고난은 인간의 진가를 증명하는 것이다.",
    author: "에피테토스",
  },
  {
    sentence: "고뇌는 철저하게 경험하는 것에 의해서만 치유될 수 있다.",
    author: "마르셀 프루스트",
  },
  {
    sentence: "장점과 훌륭한 예의는 어디서나 번영할 것이다.",
    author: "체스터필드",
  },
  {
    sentence:
      "좋은 가문에서 태어나는 것은 바람직한 일이다. 그러나 그 영광은 조상의 것이다.",
    author: "플루타르쿠스",
  },
  {
    sentence: "충고자는 아무리 신랄하여도 결코 해를 끼치지 않는다.",
    author: "푸블릴리우스 시루스",
  },
  {
    sentence:
      "먹는 것은 자신을 즐겁게 하기 위함이요. 입는 것은 남을 즐겁게 하기 위함이다.",
    author: "벤저민 프랭클린",
  },
  {
    sentence: "신사를 만드는 것은 옷이 아니다.",
    author: "속담",
  },
  {
    sentence: "재산가들 중에는 상식을 가진 자가 드물다.",
    author: "유베날리스",
  },
  {
    sentence: "행복이란 불만에 자기가 속지 않으면 된다.",
    author: "러셀",
  },
  {
    sentence: "진주를 간직하고 있는 것은 병든 궁이다.",
    author: "세드",
  },
  {
    sentence: "적은 것을 적다고 하지 말며, 천한 것을 천하게 여기지 말라.",
    author: "소자",
  },
  {
    sentence: "인간은 사회적 동물이다.",
    author: "아리스토텔레스",
  },
  {
    sentence: "모든 날 중 가장 완전히 잃어버린 날은 웃지 않은 날이다.",
    author: "샹포르",
  },
  {
    sentence: "근심은 세월을 거치지 않고 백발과 노령을 가져온다.",
    author: "속담",
  },
  {
    sentence: "권리는 어느 곳에나 도리를 벗어난 곳에서는 존재할 수 없다.",
    author: "파크",
  },
  {
    sentence: "공손과 인간성과의 관계는, 따스함과 밀초와의 관계와 같다.",
    author: "쇼펜하우어",
  },
  {
    sentence: "이기는 것이 중요한 것이 아니다. 어떻게 노력하는가가 문제이다.",
    author: "쿠베르탕",
  },
  {
    sentence:
      "두 사람의 개성의 만남은 두 가지 화학물질의 접촉과 같다. 반응이 있으면 둘 다 변화한다.",
    author: "융",
  },
  {
    sentence: "참고 버텨라. 그 고통은 차츰차츰 너에게 좋은 것으로 변할 것이다.",
    author: "오비디우스",
  },
  {
    sentence: "오래 가는 행복은 정직한 것 속에서만 발견할 수 있다.",
    author: "리히텐베르히",
  },
  {
    sentence: "누구의 말에도 귀를 기울이고 누구를 위해서도 입을 열지 말라.",
    author: "셰익스피어",
  },
  {
    sentence:
      "넌 자신을 누구에겐가 필요한 존재로 만들라. 누구에게든 인생을 고되게 만들지 말라.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence: "종소리처럼 맑고 분명해라.",
    author: "레이",
  },
  {
    sentence: "네가 고독했을 때, 나는 가장 고독하지 않다.",
    author: "마르쿠스 툴리우스 키케로",
  },
  {
    sentence: "존재하는 모든 훌륭한 것은 독창력의 열매이다.",
    author: "밀",
  },
  {
    sentence: "인내는 쓰다. 그러나 그 열매는 달다.",
    author: "장 자크 루소",
  },
  {
    sentence: "훌륭한 말은 훌륭한 무기이다.",
    author: "풀러",
  },
  {
    sentence: "어린이가 없는 곳에 천국은 없다.",
    author: "A.C. 스윈번",
  },
  {
    sentence: "말하자마자 행동하는 사람, 그것이 가치 있는 사람이다.",
    author: "엔니우스",
  },
  {
    sentence: "대화할 때의 신중은 웅변보다 더 중요하다.",
    author: "그라시안",
  },
  {
    sentence: "양심은 어떠한 과학의 힘보다도 강하고 현명하다.",
    author: "라데이러",
  },
  {
    sentence: "어리석은 짓을 삼가는 것이 지혜의 입문이다.",
    author: "호라티우스",
  },
  {
    sentence: "교육의 목표는 지식의 증진과 진리의 씨뿌리기이다.",
    author: "케네디",
  },
  {
    sentence:
      "교육이란 화를 내지 않고, 자신감을 잃지 않으면서도 거의 모든것에 귀기울일 수 있는 능력이다.",
    author: "로버트 프로스트",
  },
  {
    sentence:
      "국가는 좋은 생활을 위해서 존재하지 생활만을 위해서 존재하지 않는다.",
    author: "아리스토텔레스",
  },
  {
    sentence:
      "국가란 내일을 위한 계획을 가지고 있다는 사실에 의하여 형성되고 생명이 유지된다.",
    author: "J.오르데가이 가세트",
  },
  {
    sentence: "국가란 어머니와 같은 것이다.",
    author: "소크라테스",
  },
  {
    sentence: "국가의 가치는 결국 그것을 구성하고 있는 개개인의 가치다.",
    author: "J S 밀",
  },
  {
    sentence:
      "미소, 악수, 혹은 호의로운 눈총 등 무엇인가를 남에게 동냥할 필요가 없는 인간은 없다.",
    author: "댈버그",
  },
  {
    sentence: "아예 배우지 않느니보다는 늦으나마 배우는 편이 낫다.",
    author: "클레오 불루스",
  },
  {
    sentence: "생명이 있는 한, 사람은 무엇인가 바랄 수 있다.",
    author: "세네카",
  },
  {
    sentence: "자기 일을 멸시하는 자는 먹을 양식과 싸운다.",
    author: "스퍼전",
  },
  {
    sentence: "사람의 천성과 직업이 맞을 때 행복하다.",
    author: "베이컨",
  },
  {
    sentence: "사람은 돈지갑은 가난해도, 정신적으로는 긍지를 가질 수 있다.",
    author: "메이슨",
  },
  {
    sentence:
      "한나라의 진정한 재산은 땀 흘려 일하는 부지런한 주민의 수에 있다.",
    author: "보나파르트 나폴레옹",
  },
  {
    sentence: "사랑은 인생의 소금이다.",
    author: "J. 셰필드",
  },
  {
    sentence: "시련이란 진리로 통하는 으뜸가는 길이다.",
    author: "바이런",
  },
  {
    sentence: "사랑 없이 사는 것은 정말로 사는 것이 아니다.",
    author: "몰리에르",
  },
  {
    sentence: "얼마나 오래 사느냐가 아니라 어떻게 사느냐가 문제",
    author: "베일리",
  },
  {
    sentence: "내기는 탐욕의 아들이며, 부정의 형제이며, 불행의 아버지이다.",
    author: "워싱턴",
  },
  {
    sentence: "모든 사람의 행복은 다른 사람의 불행 위에 세워진다.",
    author: "이반 세르게예비치 투르게네프",
  },
  {
    sentence:
      "모든 양서를 읽는다는 것은 지난 몇세기 동안에 걸친 가장 훌륭한 사람들과 대화를 하는 것과 같다.",
    author: "데카르트",
  },
  {
    sentence:
      "다른 사람을 지배하려는 사람은, 먼저 자기 자신의 주인이 되어야 한다.",
    author: "매신저",
  },
  {
    sentence: "희망은 가난한 인간의 빵이다.",
    author: "탈레스",
  },
  {
    sentence: "모든 위대한 사업에도 최초에는 불가능한 일이라고 했던 것이다.",
    author: "카알라일",
  },
  {
    sentence: "빈부강약을 막론하고 일하지 않는자를 배척하라.",
    author: "루소",
  },
  {
    sentence: "시간을 이용할 줄 아는 사람은 하루를 사흘로 통용한다.",
    author: "속담",
  },
  {
    sentence: "모든 일은 어려운 고비를 넘겨야 쉬워진다.",
    author: "폴러",
  },
  {
    sentence: "우리는 지성적으로 되기 위해 많은 대가를 치른다.",
    author: "에우리피데스",
  },
  {
    sentence: "많은 친구를 가지고 있는 사람은 한 사람의 친구도 없다.",
    author: "W.글라임",
  },
  {
    sentence: "정신으로 창조된 것은 물질보다 한결 생명적이다.",
    author: "보들레르",
  },
  {
    sentence: "검약은 훌륭한 소득이다.",
    author: "에라스무스",
  },
  {
    sentence:
      "겁쟁이는 죽음에 앞서서 여러 차례 죽지만 용기있는 자는 한번밖에 죽지 않는다.",
    author: "셰익스피어",
  },
  {
    sentence: "지혜는 고통을 통해서 생긴다.",
    author: "아에스킬루스",
  },
  {
    sentence: "좋은 나무는 좋은 열매를 맺는다.",
    author: "성경",
  },
  {
    sentence: "말도 행동이고 행동도 말의 일종이다.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence: "중간이 가장 안전할 것이다.",
    author: "오비디우스",
  },
  {
    sentence:
      "행동에 부주의하지 말며, 말에 혼동되지 말며, 생각에 방황하지 말라.",
    author: "마르쿠스 아우렐리우스",
  },
  {
    sentence: "모든 개량과 진보의 근본은 근로이다.",
    author: "카네기",
  },
  {
    sentence: "모든 죄악의 기본은 조바심과 게으름이다.",
    author: "카프카",
  },
  {
    sentence: "충고는 좀처럼 환영받지 못한다.",
    author: "필립 체스터필드",
  },
  {
    sentence: "탐구정신은 우리가 살고 있는 시대의 위대한 특징이다.",
    author: "풀",
  },
  {
    sentence: "모든 위대한 진리는 처음에는 모독의 말로 출발한다.",
    author: "조지 버나드 쇼",
  },
  {
    sentence:
      "지구상에는 인간이외는 위대한 것이 없다. 인간에게는 지성 이외엔 훌륭한 것이 없다.",
    author: "헤밀턴",
  },
  {
    sentence: "험한 언덕을 오르려면 처음에는 서서히 걸어야 한다.",
    author: "셰익스피어",
  },
  {
    sentence: "논리와 상식은 다르다.",
    author: "하버드",
  },
  {
    sentence: "뇌물로 얻은 충성은 뇌물로 정복된다.",
    author: "세네카",
  },
  {
    sentence: "누구나 단번에 비상한 악인이 되는 일은 없다.",
    author: "유베나리우스",
  },
  {
    sentence:
      "많은 사물 중에서 가운데가 제일이다. 내 위치도 가운데가 되게 하라.",
    author: "포킬리데스",
  },
  {
    sentence: "자기 자신을 예찬하는 자는 신의 미움을 받는다.",
    author: "클레멘스",
  },
  {
    sentence: "악은 선을 인식시키고 고통은 기쁨을 느끼게 한다.",
    author: "성경",
  },
  {
    sentence:
      "마땅히 행할 길을 아이에게 가르쳐라. 그리하면 늙어도 그것을 떠나지 않으리라.",
    author: "성경",
  },
  {
    sentence: "근심은 미를 훔치는 도둑이다.",
    author: "마미언",
  },
  {
    sentence: "한 치의 기쁨마다 한자의 고민이 있다.",
    author: "베넘",
  },
  {
    sentence: "인간은 환경을 창조하고 환경은 인간을 창조한다.",
    author: "벤저민 ",
  },
  {
    sentence: "아름다운 것은 선하고 선한 자는 곧 아름다워진다.",
    author: "삽포",
  },
  {
    sentence:
      "공정하고 바른 데는 근거를 두었다면 긍지보다 이익을 주는 것은 좀처럼 없다.",
    author: "밀턴",
  },
  {
    sentence: "시간은 언제까지든 당신을 기다리는 것은 아니다.",
    author: "짐멜",
  },
  {
    sentence: "인생은 불확실한 항해이다.",
    author: "셰익스피어",
  },
  {
    sentence: "모든 개성에는 제각기 아름다움이 있다.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence:
      "아름다움이란 경솔한 사람이 그릇 생각하듯 보이는 그대로 외관만의 치레는 아니다.",
    author: "스펜스",
  },
  {
    sentence: "창조는 고민 속에서 나오고 발전은 고생 속에서 움튼다.",
    author: "명언",
  },
  {
    sentence: "소비된 시간은 존재하고 이용된 시간은 생명이다.",
    author: "영",
  },
  {
    sentence: "내가 아직 살아있는 동안에는 나로 하여금 헛되이 살지 않게 하라.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence: "내가 없는 곳에서 나를 칭찬해 주는 사람은 좋은 친구다.",
    author: "명언",
  },
  {
    sentence:
      "내가 처한 모든 땅에서 내가 당한 모든 일을 할 수 있도록 최선을 다하자.",
    author: "루터",
  },
  {
    sentence: "정직한 노동은 사랑스런 얼굴을 낳는다.",
    author: "대커",
  },
  {
    sentence: "인간은 이성적 동물이다.",
    author: "아리스토텔레스",
  },
  {
    sentence: "모범은 모든 사람이 읽을 수 있는 교훈이다.",
    author: "G.웨스트",
  },
  {
    sentence: "일은 시작할 때가 언제나 가장 좋다.",
    author: "파스칼",
  },
  {
    sentence: "인류의 목적은 휴식이 아니다. 그것은 지적이며 도덕적인 완성이다.",
    author: "르낭",
  },
  {
    sentence:
      "공손이란 가장 친절한 방법으로 가장 친절한 것을 향하고 말하는 것이다.",
    author: "루이전",
  },
  {
    sentence: "공인된 키스는 훔친 키스보다 감미롭지 못하다.",
    author: "모파상",
  },
  {
    sentence:
      "공정하고 바른데는 근거를 두었다면 긍지보다 이익을 주는 것은 좀처럼 없다.",
    author: "밀턴",
  },
  {
    sentence: "공화국은 사치로 멸망하며, 전제주의 국가는 빈곤으로 멸망한다.",
    author: "몽테스키에",
  },
  {
    sentence: "과거는 잊어버리고 다른 일에 몰두하자. 이것이 고민의 해결이다.",
    author: "잭 템프시",
  },
  {
    sentence:
      "과거에 한 번도 적을 만들어 본 일이 없는 인간은 결코 친구를 가질 수 없다.",
    author: "테니슨",
  },
  {
    sentence: "행실은 각자가 자기의 이미지를 보여주는 거울이다.",
    author: "괴테",
  },
  {
    sentence:
      "다른 사람을 지배하려는 사람은, 먼저 자기 자신의 주인이 되어야 한다.",
    author: "매신저",
  },
  {
    sentence:
      "위대한 것을 멸시하고, 과도함보다는 중용을 택하는 것이 군자의 특징이다.",
    author: "세네카",
  },
  {
    sentence: "목적 없이 존재하는 것은 아무 것도 없다.",
    author: "보들레르",
  },
  {
    sentence: "전력을 다해서 시간에 대항하라.",
    author: "톨스토이",
  },
  {
    sentence: "인생에서 중요한 법칙은 만사에 중용을 지키는 일이다.",
    author: "테렌티우스",
  },
  {
    sentence: "덕은 중용을 지키는데 있다.",
    author: "아리스토텔레스",
  },
  {
    sentence: "다정하고 조용한 말은 힘이 있다.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence: "돈이 있어도 이상이 없는 사람은 몰락의 길을 밟는다.",
    author: "도스도예프스키",
  },
  {
    sentence:
      "마음의 즐거움은 얼굴을 빛나게 하여도 마음의 근심은 심령을 상하게 하느니라.",
    author: "성경",
  },
  {
    sentence: "평온한 마음으로 아껴 생활하는 것이 사람에게 큰 부이다.",
    author: "루크레티우스",
  },
  {
    sentence: "버들가지는 약하나 다른 재목을 묶는다.",
    author: "하버트",
  },
  {
    sentence: "사람의 잘못은 좀처럼 자신에게는 나타나지 않는다.",
    author: "셰익스피어",
  },
  {
    sentence: "부당한 이득을 얻지 말라. 그것은 손해와 같은 것이다.",
    author: "헤시오도스",
  },
  {
    sentence: "근로가 잠들면 빈곤은 창으로 들어온다.",
    author: "라이닉",
  },
  {
    sentence: "자기가 할 수 있는 일은 남에게 밀지 말라.",
    author: "제퍼슨",
  },
  {
    sentence: "최초의 큰 웃음보다는 마지막의 미소가 오히려 낫다.",
    author: "속담",
  },
  {
    sentence: "쓴 맛을 보기 전에 단 맛을 보아서는 안 된다.",
    author: "고울딤 헴",
  },
  {
    sentence: "조금 알기 위해서 많이 공부해야 한다.",
    author: "몽테스키외",
  },
  {
    sentence:
      "많이 가진 사람은 더 많은 것을 손에 넣는다. 조금밖에 갖지 못한 사람은 그것마저 빼앗긴다.",
    author: "하인리히 하이네",
  },
  {
    sentence: "상식은 그렇게 흔한 것이 아니다.",
    author: "볼테르",
  },
  {
    sentence: "훌륭한 충고보다 값진 선물은 없다.",
    author: "에라스무스",
  },
  {
    sentence: "사자라 할지라도 파리들로부터 자기 몸을 방어해야 한다.",
    author: "속담",
  },
  {
    sentence: "나 자신의 무식을 아는 것은 지식에로의 첫걸음이다.",
    author: "바이런",
  },
  {
    sentence:
      "내 차라리 하룻동안 계율을 지키다가 죽을지언정 백년 동안 계율을 깨뜨리고서 살기를 원하지 않는다.",
    author: "자장(慈藏)",
  },
  {
    sentence: "너는 네가 가장 가까이 있는 의무를 수행하라.",
    author: "킹그슬리",
  },
  {
    sentence:
      "너무 많다는 것은 부족하다는 것을 의미한다. 너무 건강한 사람같이 심한 병자는 없다.",
    author: "로맹 롤랑",
  },
  {
    sentence: "가장 훌륭한 예언은 상식, 즉 우리의 원래의 지혜이다.",
    author: "에우리피데스",
  },
  {
    sentence: "행복하게 산다는 것은 마음의 평온함을 뜻한다.",
    author: "시세로",
  },
  {
    sentence: "자기 자신을 아는 것은 참된 진보이다.",
    author: "안데르센",
  },
  {
    sentence: "배우라. 비교하라. 사실을 수입하라.",
    author: "파플로프",
  },
  {
    sentence: "할 수 있는 한 훌륭한 인생을 만들라. 인생은 짧고 곧 지나간다.",
    author: "오울디즈",
  },
  {
    sentence: "군자는 기회가 없다고 불평하지 않는다.",
    author: "에머슨",
  },
  {
    sentence: "두 사람의 머리는 한 사람의 머리보다 낫다.",
    author: "헤이우드",
  },
  {
    sentence: "탐구하여 찾아질 수 없을 정도로 어려운 문제는 존재하지 않는다.",
    author: "티랜티우스",
  },
  {
    sentence: "인간은 천에 따라서 자기 옷을 지어야 한다.",
    author: "내쉬",
  },
  {
    sentence: "아이들에게는 비평보다도 귀감이 필요하다.",
    author: "쥬벨",
  },
  {
    sentence: "큰 나무는 바람을 많이 받는다.",
    author: "카네기",
  },
  {
    sentence: "담화는 마음의 보다 즐거운 향연이다.",
    author: "호메로스",
  },
  {
    sentence: "뿌리가 튼튼해야 열매가 많다.",
    author: "용비어천가",
  },
  {
    sentence: "서투른 의사소통은, 훌륭한 예절을 망쳐버린다.",
    author: "메난드로스",
  },
  {
    sentence: "마음이 어진 사람은 조그마한 집에 살아도 행복하다.",
    author: "홍자성",
  },
  {
    sentence: "마음이 없으면 보고도 안 보이고 들어도 귀에 들리지 않는다.",
    author: "속담",
  },
  {
    sentence: "일의 기량을 닦기 위해서 가장 중요한 것은 실행과 경험이다.",
    author: "콜루멜라",
  },
  {
    sentence:
      "만 가지 이치, 하나의 근원은 단번에 깨쳐지는 것이 아니므로 참마음, 진실된 본체는 애써 연구하는데 있다.",
    author: "퇴계 이황",
  },
  {
    sentence: "산 기계를 만들지 말고, 인간을 만들라.",
    author: "페스탈로치",
  },
  {
    sentence: "다른 인간을 증오하는 대가는, 자신을 더 적게 사랑하는 것이다.",
    author: "클리버",
  },
  {
    sentence: "깨끗한 의복은 좋은 소개장",
    author: "속담",
  },
  {
    sentence:
      "당나귀는 긴 귀로 구별할 수 있으며 어리석은 자는 긴 혀로 구별할 수 있다.",
    author: "유태 격언",
  },
  {
    sentence: "깨닫기만 하고 실천을 안하면 깨달음이 아무 소용없다.",
    author: "힐티",
  },
  {
    sentence:
      "다른 사람의 속마음으로 들어가라. 그리고 다른 사람으로 하여금 당신의 속마음으로 들어오도록 하라.",
    author: "아우렐리우스",
  },
  {
    sentence: "꿈을 품고 무언가 할 수 있다면 그것을 시작하라.",
    author: "요한 볼프강 폰 괴테",
  },
  {
    sentence:
      "새로운 일을 시작하는 용기 속에 당신의 천재성과 능력과 기적이 모두 숨어 있다.",
    author: "요한 볼프강 폰 괴테",
  },
  {
    sentence: "끝나 버리기 전에는 무슨 일이든 불가능하다고 생각하지 말라.",
    author: "마르쿠스 툴리우스 키케로",
  },
  {
    sentence: "안심하면서 먹는 한 조각 빵이 근심하면서 먹는 잔치보다 낫다.",
    author: "이솝",
  },
  {
    sentence: "나는 나 자신을 빼놓고는 모두 안다.",
    author: "비용",
  },
  {
    sentence: "마음보다 더 잔인한 무기는 없다.",
    author: "장자(莊子)",
  },
  {
    sentence: "두 여인을 화합시키기 보다는 유럽 전체를 화합시키는 편이 쉽다.",
    author: "루이 14세",
  },
  {
    sentence:
      "나는 내가 알기 원하는 것을 배우려면 늙어야 하겠고, 내가 아는 것을 말하기 위해서는 젊어야 하겠다.",
    author: "조제프 주베르",
  },
  {
    sentence: "강한 사람이란 가장 훌륭하게 고독을 견디어 낸 사람이다.",
    author: "쉴러",
  },
  {
    sentence: "고독은 지혜의 최선의 유모다.",
    author: "로런스 시테르네",
  },
  {
    sentence: "돈은 최선의 종이요 최악의 주인이다.",
    author: "프란시스 베이컨",
  },
  {
    sentence: "고립된 개인은 존재하지 않는다. 슬픈자는 타인을 슬프게 한다.",
    author: "앙투안 드 생텍쥐페리",
  },
  {
    sentence: "강한 인간이 되고 싶다면 물과 같아야 한다.",
    author: "노자(老子)",
  },
  {
    sentence:
      "개선으로부터 몰락까지의 거리는 단 한걸음에 지나지 않는다. 사소한 일이 가장 큰 일을 결정함을 보았다.",
    author: "보나파르트 나폴레옹",
  },
  {
    sentence: "개성과 인간과의 관계는 향기와 꽃과의 관계이다.",
    author: "시위브",
  },
  {
    sentence: "고통을 주지 않는 것은 쾌락도 주지 않는다.",
    author: "몽테뉴",
  },
  {
    sentence:
      "고통은 인간의 위대한 교사이다. 고통의 숨결 속에서 영혼은 발육된다.",
    author: "에센 바하",
  },
  {
    sentence: "거지에게 침대를 주면 거지는 보답으로 이를 줄 것이다.",
    author: "레이",
  },
  {
    sentence: "거짓말은 눈사람 같아서 오래 굴리면 그만큼 더 커진다.",
    author: "로터",
  },
  {
    sentence: "거짓말을 한 그 순간부터 뛰어난 기억력이 필요하게 된다.",
    author: "코르네이유",
  },
  {
    sentence: "걱정없는 인생을 바라지 말고 걱정에 물들지 않는 연습을 하라.",
    author: "알랭",
  },
  {
    sentence: "건강과 부는 미를 창조한다.",
    author: "H.G.보운",
  },
  {
    sentence: "건강과 지성은 인생의 두가지 복이다.",
    author: "메난드로스",
  },
  {
    sentence: "건강은 행복의 어머니이다.",
    author: "프란시스 톰슨",
  },
  {
    sentence: "내 비장의 무기는 아직 손 안에 있다. 그것은 희망이다",
    author: "보나파르트 나폴레옹",
  },
  {
    sentence: "내 사전에 불가능은 없다.",
    author: "보나파르트 나폴레옹",
  },
  {
    sentence: "내일에 아무런 도움이 되지 않는다면 당신의 과거는 쫓아버려라.",
    author: "오슬러",
  },
  {
    sentence: "만약 급히 서두르려면 돌아가는 길로 가라.",
    author: "속담",
  },
  {
    sentence:
      "만약 자기의 의견을 들어주는 합법수단이 거절되었을 때에는 국민은 폭력으로 호소할 권리가 있다.",
    author: "앙드레 모루아",
  },
  {
    sentence: "덕이 없는 아름다움은 향기 없는 꽃이다.",
    author: "격언",
  },
  {
    sentence: "인간성 이외에는 본질적으로 진실한 것은 없다.",
    author: "오귀스트 콩트",
  },
  {
    sentence: "화가 나면 열을 세어라. 풀리지 않는다면 백을 세어라.",
    author: "제퍼슨",
  },
  {
    sentence: "날이 밝기 직전에 항상 가장 어둡다.",
    author: "풀러",
  },
  {
    sentence:
      "만약 평화가 명예로써 유지되지 못한다면, 그런 평화는 아무런 가치도 없다.",
    author: "러셀",
  },
  {
    sentence:
      "남에게 부정하게 대하지 말 것이며, 남이 나에게 부정하지 못하게 하라.",
    author: "마호메트",
  },
  {
    sentence:
      "만일 자유 사회가 가난한 다수를 도울 수 없다면 부유한 소수도 구원할 수 없다.",
    author: "케네디",
  },
  {
    sentence: "미련한 자는 자기 행위를 바른 줄로 여긴다.",
    author: "성경",
  },
  {
    sentence: "모든 국가의 기초는 그 나라 젊은이들의 교육이다.",
    author: "디오게네스",
  },
  {
    sentence: "곡선은 신의 선이고, 직선은 인간의 선이다",
    author: "안토니 가우디",
  },
  {
    sentence: "마음에 고민이 있는 자의 하루는 낱낱이 어려운 일뿐인 것이다.",
    author: "구약성서",
  },
  {
    sentence: "인간은 죽을 때까지 완전한 인간이 못 된다.",
    author: "플랭클린",
  },
  {
    sentence: "자기가 가고 있는 곳을 모르는 사람은 결코 높이 향상하지 못한다.",
    author: "크롬웰",
  },
  {
    sentence: "진정한 벗은 제2의 자기인 것이다.",
    author: "아리스토텔레스",
  },
  {
    sentence: "모든 기술 중에서 제일이며 가장 존경을 받는 것은 농업이다.",
    author: "장 자크 루소",
  },
  {
    sentence: "자신을 알 수 있는 사람이야말로 진정한 현인이다.",
    author: "초서",
  },
  {
    sentence: "시기와 질투는 언제나 남을 쏘려다가 결국 자신을 쏜다.",
    author: "맹자(孟子)",
  },
  {
    sentence: "진정한 위인치고 자신을 위인으로 생각하는 자는 없다.",
    author: "해즐리트",
  },
  {
    sentence: "폭풍은 참나무가 더욱 뿌리를 깊게 박도록 한다.",
    author: "허버트",
  },
  {
    sentence:
      "건강이 있는 곳에 자유가 있다. 건강은 모든 자유중에서 으뜸가는 것이다.",
    author: "앙리 프레데리크 아미엘",
  },
  {
    sentence: "건강한 신체에 건강한 정신",
    author: "유베날리스",
  },
  {
    sentence: "즐거움에 찬 얼굴은 한 접시의 물로도 연회를 만들 수 있다.",
    author: "허버트",
  },
  {
    sentence: "대화는 학생들의 실험실이요, 작업장이다.",
    author: "랠프 월도 에머슨",
  },
  {
    sentence: "대화시의 신중은 웅변보다 더 중요하다.",
    author: "그라시안",
  },
  {
    sentence: "미지를 향해 출발하는 사람은 누구나 외로운 모험에 만족해야 한다.",
    author: "지드",
  },
  {
    sentence: "노동은 생명이요, 사상이요, 광명이다.",
    author: "위고",
  },
  {
    sentence: "마음의 고통은 육체적 고통보다 훨씬 크다.",
    author: "사일러스",
  },
  {
    sentence: "노령에 활기를 주는 진정한 방법은 마음의 청춘을 연장하는 것이다.",
    author: "콜린즈",
  },
  {
    sentence: "노병은 결코 죽지 않고 사라질 뿐이다.",
    author: "맥아더",
  },
  {
    sentence: "하나의 작은 꽃을 만드는 데도 오랜 세월의 노력이 필요하다.",
    author: "블레이크",
  },
  {
    sentence: "인간은 교육을 통하지 않고는 인간이 될 수 없는 유일한 존재이다.",
    author: "칸트",
  },
  {
    sentence: "노년은 청춘에 못지 않은 좋은 기회이다.",
    author: "롱펠로우",
  },
  {
    sentence:
      "노동은 인류를 괴롭히는 온갖 질병과 비참에 대한 최고의 치료법이다.",
    author: "토마스 칼라일",
  },
  {
    sentence:
      "노동은 인생을 감미롭게 한다. 노동을 미워하는 자만이 고뇌를 맛본다.",
    author: "월 헤름 브르만",
  },
  {
    sentence: "한 손으로 다른 손을 씻고, 두 손으로 얼굴을 씻는다.",
    author: "플로리오",
  },
  {
    sentence: "우리의 거의 모든 삶이 어리석은 호기심에 낭비되고 있다.",
    author: "보들레르",
  },
  {
    sentence: "풍랑은 항상 능력 있는 항해자 편이다.",
    author: "기번",
  },
  {
    sentence: "말 한마디가 세계를 지배한다.",
    author: "루크",
  },
  {
    sentence: "우리들은 감탄과 희망과 사랑으로 산다.",
    author: "워즈워드",
  },
  {
    sentence: "단 하나의 하늘에 올려진 고마워하는 생각이 완전한 기도이다.",
    author: "레싱",
  },
  {
    sentence: "말만 하고 행동하지 않는 사람은 잡초로 가득 찬 정원과 같다.",
    author: "하우얼",
  },
  {
    sentence: "지식이 깊은 사람은 시간의 손실을 가장 슬퍼한다.",
    author: "단테",
  },
  {
    sentence: "미는 내부의 생명으로부터 나오는 빛이다.",
    author: "켈러",
  },
  {
    sentence: "자신이 자신의 지휘관이다.",
    author: "플라우투스",
  },
  {
    sentence: "오늘 가장 좋게 웃는 자는 역시 최후에도 웃을 것이다.",
    author: "니체",
  },
  {
    sentence: "영혼이 깃든 청춘은 그렇게 쉽사리 사라지지 않는다.",
    author: "카로사",
  },
  {
    sentence:
      "노령에 활기를 주는 진정한 방법은, 마음의 청춘을 연장하는 것이다.",
    author: "콜린즈",
  },
  {
    sentence: "결백한 자와 미인은, 시간 이외에는 적이 없다.",
    author: "예이츠",
  },
  {
    sentence: "결점 없는 사람을 고르다간 끝내 벗을 얻을 수 없다.",
    author: "속담",
  },
  {
    sentence: "너의 위대한 조상을 본받아 행동하라.",
    author: "드라이든",
  },
  {
    sentence: "지혜의 가장 명백한 징조는 쉴 새 없이 명랑한 것이다.",
    author: "몽테뉴",
  },
  {
    sentence: "아름다운 것! 그것은 마음의 눈으로 보이는 미",
    author: "주베르",
  },
  {
    sentence: "많은 사람이 충고를 받지만, 오직 현명한 자만이 충고의 덕을 본다.",
    author: "푸블릴리우스 시루스",
  },
  {
    sentence: "정당하게 사는 자에게는 어느 곳이든 안전하다.",
    author: "에픽테투스",
  },
  {
    sentence: "지혜는 간혹 누더기 가면을 덮어쓰고 있다.",
    author: "스타티우스",
  },
  {
    sentence:
      "창조적인 예술가는 그 전의 작품에 만족하지 않기 때문에 다음 작품을 만든다.",
    author: "쇼스타코비치",
  },
  {
    sentence: "위기의 시기에는 가장 대담한 방법이 때로는 가장 안전하다.",
    author: "키신저",
  },
  {
    sentence: "하늘을 우러러 한 점 부끄럼이 없기를",
    author: "윤동주",
  },
  {
    sentence: "흙에서 자란 내마음 파란 하늘빛",
    author: "정지용",
  },
  {
    sentence: "넓은벌 동쪽끝으로 옛이야기",
    author: "정지용",
  },
  {
    sentence: "붉은 파밭의 푸른 새싹을 보아라.",
    author: "김수영",
  },
  {
    sentence: "손금에는 맑은 강물이 흐르고",
    author: "윤동주",
  },
  {
    sentence: "햇빛도 그늘이 있어야 맑고 눈이 부시다.",
    author: "정호승",
  },
  {
    sentence: "엷은 졸음에 겨운 늙으신 아버지가",
    author: "정지용",
  },
  {
    sentence: "격의 없이 터놓은 관계라도 기본 예는 갖춤이 옳거니",
    author: "2008년 9월",
  },
  {
    sentence: "이 많은 별빛이 내린 언덕 위에",
    author: "윤동주",
  },
  {
    sentence: "자연은 우리에게 많은 것을 아낌없이 베풀어주고 있다.",
    author: "법정",
  },
  {
    sentence: "젊을 때 배움을 소홀히 하면 미래가 없다",
    author: "2009년 6월",
  },
  {
    sentence: "그 맑은 눈빛으로 나를 씻어",
    author: "이성선",
  },
  {
    sentence: "맑은 강물처럼 조용하고 은근하며",
    author: "유안진",
  },
  {
    sentence: "사람은 나이로 늙는 것이 아니라 기분으로 늙는다.",
    author: "2010년 3월",
  },
  {
    sentence: "장닭 꼬리 날리는 하얀 바람 봄길",
    author: "이성선",
  },
  {
    sentence: "포도빛 향기에 취해만 가는데",
    author: "채바다",
  },
  {
    sentence: "얼음장을 뚫고 바다에 당도한 저 푸른 강물",
    author: "안도현",
  },
  {
    sentence: "날마다 새로우며, 깊어지며, 넓어진다.",
    author: "정채봉",
  },
  {
    sentence: "일상에 얽매이지 말고 자유로운 삶을 살다",
    author: "2011년 3월",
  },
  {
    sentence: "생명의 꽃을 피우는 미나리 빛깔의 봄",
    author: "이해인",
  },
  {
    sentence: "산 넘어 또 오를 산이 없다면 삶은 얼마나 밋밋할까",
    author: "2011년 6월",
  },
  {
    sentence: "맑은 이슬은 달빛 아래 흰 구슬을 이루고",
    author: "2011년 7월",
  },
  {
    sentence: "세월이 흘러도 어머니의 마음은 늙지 않았습니다",
    author: "2011년 9월",
  },
  {
    sentence: "꿈은 힘든 생활을 헤쳐나가는 힘",
    author: "2011년 9월",
  },
  {
    sentence: "희망의 빛을 품고 꿈을 향해 나아가는",
    author: "2011년 9월",
  },
  {
    sentence: "진정 오늘밖엔 없는 것처럼 시간을 아껴 쓰고",
    author: "이해인",
  },
  {
    sentence: "진실로 내가 그대를 사랑하는 까닭은",
    author: "황동규",
  },
  {
    sentence: "시냇물에 잠긴 하얀 조각돌처럼",
    author: "이해인",
  },
  {
    sentence: "꽃은 젖어도 향기는 젖지 않는다",
    author: "도종환",
  },
  {
    sentence: "언젠가 먼 훗날에 저 넓고 거칠은 세상 끝 바다로 갈거라고",
    author: "패닉",
  },
  {
    sentence: "많이 사랑하고 더 나중까지 지켜주는 이 됩시다",
    author: "김남조",
  },
  {
    sentence: "풀섶 이슬에 함초롬 휘적시던 곳",
    author: "정지용",
  },
  {
    sentence: "밝고 맑게 살아가는 희망의 사람이 되게",
    author: "이해인",
  },
  {
    sentence: "하루가 힘들어도 미래를 위해 꿈을 꾼다",
    author: "2012년 9월",
  },
  {
    sentence: "삶의 울타리에 평안함이 가득하다는 것이다",
    author: "용혜원",
  },
  {
    sentence: "썰물이 훑고 간 갯바닥의 나문재들은 더욱 붉었다",
    author: "2012년 10월",
  },
  {
    sentence: "달은 하늘 깊은 곳에 이르러 새벽을 달리는데",
    author: "소강절",
  },
  {
    sentence: "맑은 햇빛으로 반짝반짝 물들으며",
    author: "정한모",
  },
  {
    sentence: "밝고 환한 빛으로 들꽃처럼 웃었지요",
    author: "김용택",
  },
  {
    sentence: "봄비가 초록잎에 생명을 불어 넣듯이",
    author: "2013년 4월",
  },
  {
    sentence: "햇빛이 선명하게 나뭇잎을 핥고 있었다",
    author: "한수산",
  },
  {
    sentence: "꽃씨들은 흙을 뚫고 얼음을 뚫고",
    author: "권정생",
  },
  {
    sentence: "희망의 샘 하나 출렁이고 있을 것만 같다.",
    author: "곽재구",
  },
  {
    sentence: "신선한 물고기가 튀는 빛의 꼬리를 물고 쏟아진다",
    author: "전봉건",
  },
  {
    sentence: "연꽃 같은 팔꿈치로 가이 없는 바다를 밟고",
    author: "한용운",
  },
  {
    sentence: "달빛이 밀물처럼 밀려왔구나",
    author: "장만영",
  },
  {
    sentence: "광활한 들녘에 씨알 하나",
    author: "2013년 11월",
  },
  {
    sentence: "꽃초롱 불 밝히듯 눈을 밝힐까",
    author: "박정만",
  },
  {
    sentence: "청노루 맑은 눈에 도는 구름",
    author: "박목월",
  },
  {
    sentence: "거친 돌이 다듬어져 조각이 되듯",
    author: "2014년 6월",
  },
  {
    sentence: "별을 보고 걸어가는 사람이 되라.",
    author: "정호승",
  },
  {
    sentence: "내려갈 때 보았네 올라갈 때 못 본 그 꽃",
    author: "고은",
  },
  {
    sentence: "눈 맑은 사람아 마음 맑은 사람아",
    author: "이성선",
  },
  {
    sentence: "눈꽃의 화음에 귀를 적신다",
    author: "곽재구",
  },
  {
    sentence: "나중 난 뿔이 우뚝하다",
    author: "속담",
  },
  {
    sentence: "햇살도 둥글둥글하게 뭉치는 맑은 날",
    author: "문태준",
  },
  {
    sentence: "티 없이 맑은 영원의 하늘",
    author: "신동엽",
  },
  {
    sentence: "깊고 넓은 감정의 바다가 있다",
    author: "김춘수",
  },
  {
    sentence: "들판을 가르는 푸른 바람처럼",
    author: "2015년 6월",
  },
  {
    sentence: "깊은 숲 속에서 나오니 유월의 햇빛이 밝다",
    author: "김달진",
  },
  {
    sentence: "제 삶의 길을 묵묵히 가는 마음 하나 곱게 간직하고 싶다.",
    author: "롱 펠로우",
  },
  {
    sentence: "꽃이 진다고 그대를 잊은 적 없다.",
    author: "정호승",
  },
  {
    sentence: "뭉툭하게 닳은 연필심으로 만들어 가는 내 꿈",
    author: "2015년 9월",
  },
  {
    sentence: "제 몫의 삶 지켜가는 청단풍 한 그루",
    author: "김광규",
  },
  {
    sentence: "단풍 곱게 물든 햇살 맑은 가을날",
    author: "김근해",
  },
  {
    sentence: "울림이 있어야 삶이 신선하고 활기차다.",
    author: "법정",
  },
  {
    sentence: "넓음과 깊음을 가슴에 채우며",
    author: "주요한",
  },
  {
    sentence: "마음속에 찰랑이는 맑고 고운 말 한마디",
    author: "이해인",
  },
  {
    sentence: "너는 나에게, 나는 너에게 잊혀지지 않는 하나의 눈짓이 되고 싶다.",
    author: "김춘수",
  },
  {
    sentence: "눈부신 초록의 노래처럼 향기처럼",
    author: "이해인",
  },
  {
    sentence: "등불을 밝혀 어둠을 조금 내몰고",
    author: "윤동주",
  },
  {
    sentence: "그대, 참 괜찮은 사람. 함께라 더 좋은 사람.",
    author: "2016년 7월",
  },
  {
    sentence: "희망은 삶을 견고하게 지탱해주는 굵은 동아줄이다.",
    author: "2016년 9월",
  },
  {
    sentence: "하염없는 빛 하염없는 기쁨",
    author: "강은교",
  },
  {
    sentence: "한 알의 작은 꽃씨 속에 모여 앉은 가을",
    author: "문병란",
  },
  {
    sentence: "눈 맑고 가슴 맑은 보고 싶은 사람아",
    author: "이성선",
  },
  {
    sentence: "넌 머지않아 예쁜 꽃이 될 테니까",
    author: "박치성",
  },
  {
    sentence: "내 안의 두 눈과 마음 문을 활짝 열고",
    author: "원성스님",
  },
  {
    sentence: "맑은 풍금 소리 미루나무 잎이 되다.",
    author: "나태주",
  },
  {
    sentence: "바람은 자도 마음은 자지 않는다.",
    author: "곽재구",
  },
  {
    sentence: "아름다운 네 모습 잃지 않았으면",
    author: "2017년 7월",
  },
  {
    sentence: "행복하다 말하면 맑아지는 마음",
    author: "2017년 9월",
  },
  {
    sentence: "달이 밝고 구름이 흐르고 하늘이 펼치고",
    author: "윤동주",
  },
  {
    sentence: "당당하게, 겸손 잃지 않은 채 피어나는 꽃",
    author: "손병흥",
  },
  {
    sentence: "큰 바다 넓은 하늘을 우리는 가졌노라.",
    author: "김영랑",
  },
  {
    sentence: "아, 생각만 해도 참 좋은 당신",
    author: "김용택",
  },
  {
    sentence: "언제나 세상은 그대로이며 눈부시게 아름답지 않은가?",
    author: "전진탁",
  },
  {
    sentence: "어제도 가고 오늘도 갈 나의 길 새로운 길",
    author: "윤동주",
  },
  {
    sentence: "하늘빛을 닮은 그 들판 곁에 서서",
    author: "박남준",
  },
  {
    sentence: "묵묵히 빛 밝혀 세상을 지켜낸 태양보다 값진 어제를 바라다 보자.",
    author: "김춘경",
  },
  {
    sentence: "너 앉은 그 자리가 바로 희망 꽃자리",
    author: "구상",
  },
  {
    sentence: "그대 맑은 눈을 들어 나를 보느니",
    author: "조지훈",
  },
  {
    sentence: "밝고 환한 빛으로 내 앞에 서서 들꽃처럼 깨끗하게 웃었지요.",
    author: "김용택",
  },
  {
    sentence: "그대만큼 사랑스러운 사람을 본 일이 없다.",
    author: "김남조",
  },
  {
    sentence: "그대가 가는 길이 아름다운 꽃길이다.",
    author: "2018년 11월",
  },
  {
    sentence: "두꺼운 땅껍질 뚫고 나오는 아주 작은 힘",
    author: "남낙현",
  },
  {
    sentence: "고마움의 꽃망울이 터지는 봄",
    author: "이해인",
  },
  {
    sentence: "꿈이 그대를 춤추게 하라.",
    author: "고도원",
  },
  {
    sentence: "넓은 하늘의 수만 별을 그대로 총총",
    author: "김영랑",
  },
  {
    sentence: "삶의 힘이 끝없이 자라는 우리들",
    author: "2019년 7월",
  },
  {
    sentence: "우리의 삶 자체가 하나의 꽃밭이 될 테지요?",
    author: "이해인",
  },
  {
    sentence: "맑고 아름다운 하늘을 받들어",
    author: "조지훈",
  },
  {
    sentence: "내 삶의 나날들을 기쁨으로 아름답게",
    author: "김준엽",
  },
  {
    sentence: "너무 맑고 초롱한 그 중 하나 별이여.",
    author: "박두진",
  },
  {
    sentence: "가장 아름다운 열매를 위한 시간",
    author: "김현승",
  },
  {
    sentence: "얼음 뚫고 봄의 빗장 열어 마주하는 희망",
    author: "2020년 3월",
  },
  {
    sentence: "바람들은 맑은 햇살을 뿌리며 응달의 강기슭을 돌아가는데",
    author: "곽재구",
  },
  {
    sentence: "모두가 이름 붙어 있지 않은 보석들",
    author: "성찬경",
  },
  {
    sentence: "내게 오는 모든 것은 다 축복이었다",
    author: "도종환",
  },
  {
    sentence: "많이 사랑할수록 더 맑게 흐르는",
    author: "이해인",
  },
  {
    sentence: "풀의 싹들이 흙덩이의 무게를 치받고 땅 위로 올라오는 것이 아니고",
    author: "김훈",
  },
  {
    sentence: "바위는 제자리에 옴찍 않노니",
    author: "조지훈",
  },
  {
    sentence: "환한 빛으로 반짝이는 삶의 굽이에서",
    author: "2020년 9월",
  },
  {
    sentence: "금이 아름답다는 것을 알게되면 별이 아름답다는 것을 잊어버린다.",
    author: "독일속담",
  },
  {
    sentence:
      "가진 게 망치밖에 없을 땐 세상의 모든 문제가 못대가리로 보이게 마련이다.",
    author: "에브라함 마즐로",
  },
  {
    sentence: "흥미로운 삶을 보장하는 것은 재미있게 놀 줄 아는 상상력이다.",
    author: "유병만 <상상하여 창조하라>",
  },
  {
    sentence: "동작을 행동으로 오해하지 마라.",
    author: "어니스트 헤밍웨이",
  },
  {
    sentence: "아름다운 서울의 야경은 야근으로 만들어진 것이다.",
    author: "Night View",
  },
  {
    sentence:
      "우리를 괴롭히는 것은 먼 산이 아니라 신발 속에 들어간 작은 모래다.",
    author: "중국 속담",
  },
  {
    sentence: "상식이란 18세까지 몸에 익힌 편견의 컬렉션을 말한다.",
    author: "알버트 아인슈타인",
  },
  {
    sentence: "불행은 누가 진정한 친구가 아닌지를 보여준다.",
    author: "아리스토텔레스",
  },
  {
    sentence: "매일 맑은 날만 계속 된다면 이 세상은 사막이 되었을 것이다.",
    author: "김제동",
  },
  {
    sentence:
      "어른이 된다는 것은 계기판은 210까지 있지만 60으로 밖에 달릴 수 없는 것.",
    author: "러브 미 이프유데어",
  },
  {
    sentence: "사랑하는 것은 용기지만 사랑받는 것은 능력이다.",
    author: "명언",
  },
  {
    sentence: "성공의 8할은 일단 출석하는 것이다.",
    author: "우디 알렌",
  },
  {
    sentence:
      "반짝이는 모든 것이 금이 아니듯이 방랑자들이 모두 길을 잃은 것은 아니다.",
    author: "반지의 제왕",
  },
  {
    sentence: "자신감을 잃으면 그 순간 온 세상이 적이 된다.",
    author: "랠프에머슨",
  },
  {
    sentence: "타인의 눈물은 물과 다름 없다.",
    author: "러시아 속담",
  },
  {
    sentence: "인생에서 가장 큰 공백은 아는 것과 행동하는 것 사이에 있다.",
    author: "딕 빅스",
  },
  {
    sentence: "흔히 사람들은 바쁘게 움직이면 일에 대한 열정이 있다고 착각한다.",
    author: "피터 드러커",
  },
  {
    sentence: "개가 싸울 때 중요한 것은 몸집이 아니라 싸우겠다는 의지다.",
    author: "드와이트 D. 아이젠하워",
  },
  {
    sentence: "높은 벽은 그것을 넘었을 때 당신을 지키는 담장이 된다.",
    author: "2ch",
  },
  {
    sentence: "훌륭한 행동이 훌륭한 말보다 낫다.",
    author: "벤자민 프랭클린",
  },
  {
    sentence:
      "연습을 했다고 완벽하게 되는 것은 아니다. 완벽하게 연습을 했을 때만 완벽하게 된다.",
    author: "빈스 룸바르디",
  },
  {
    sentence: "서서 바다를 노려보기만 해서는 바다를 건널 수 없다.",
    author: "타고르",
  },
  {
    sentence:
      "사진은 한 시간이면 배울 수 있다. 그러나 배울 수 없는 것은 바로 느낌과 감각이다.",
    author: "나다르",
  },
  {
    sentence: "천천히 가는걸 두려워 말고 가다가 멈추게 될까를 두려워하라.",
    author: "중국 격언",
  },
  {
    sentence: "모두의 책임은 아무의 책임도 아니다.",
    author: "명언",
  },
  {
    sentence:
      "생선이 소금에 절임을 당하고 얼음에 냉장을 당하는 고통이 없다면, 썩는 길 밖에 없다.",
    author: "정채봉",
  },
  {
    sentence: "가시에 찔리지 않고서는 장미를 모을 수 없다.",
    author: "필페이",
  },
  {
    sentence:
      "아무리 좋아하는 곡이라 해도 알람 소리로 설정해두면 결국 싫어지는 법이다.",
    author: "작자미상",
  },
  {
    sentence:
      "배는 항구에 있을 때 가장 안전하다. 그러나 그것이 배의 존재 이유는 아니다.",
    author: "요한 볼프강 폰 리테",
  },
  {
    sentence: "이기는 것이 전부는 아니지만, 이기기를 원하는 것은 중요하다.",
    author: "명언",
  },
  {
    sentence:
      "재능이 없다고 말하는 사람들은 대부분 별로 시도해 본 일이 없는 사람들이다.",
    author: "앤드류 매튜스",
  },
  {
    sentence:
      "변명이나 핑계를 위해 사람은 얼마든지 솔직할 수 있다. 진실과 별개로..",
    author: "미생",
  },
  {
    sentence: "쌀쌀맞게 하려면 처음부터, 상냥하게 하려면 끝까지.",
    author: "2ch",
  },
  {
    sentence: "감옥과 수도원의 차이는 불평을 하느냐 감사를 하느냐다.",
    author: "마쓰시타 고노스케",
  },
  {
    sentence:
      "내가 맞았을 땐 아무도 기억 못하는데, 내가 틀렸을 땐 다 기억한다.",
    author: "명언",
  },
  {
    sentence:
      "사랑했던 것들은 모두 나를 비껴갔다. 세월만이 정면으로 달려와 내게 충돌한다.",
    author: "예현연",
  },
  {
    sentence: "청춘이란 인생의 어떤 기간이 아니라 마음의 상태를 말한다.",
    author: "사무엘 울만",
  },
  {
    sentence:
      "운동할 시간이 없다고 생각하는 사람들은 조만간 병드는 시간을 갖게 될 것이다.",
    author: "에드워드 스탠리",
  },
  {
    sentence:
      "만약 모든 사람의 충고대로 집을 짓는다면 비뚤어진 집을 짓게 될 것이다.",
    author: "마이클린버그",
  },
  {
    sentence:
      "인생은 곱셈이다. 어떤 찬스가 와도 내가 제로면 아무런 의미가 없다.",
    author: "나카무라 미츠루",
  },
  {
    sentence: "신은 모든 곳에 있을 수 없기에 어머니를 만들었다.",
    author: "유태인 격언",
  },
  {
    sentence: "노를 젓다가 노를 놓쳐버렸다. 비로소 넓은 물을 돌아다보았다.",
    author: "순간의 꽃",
  },
  {
    sentence: "행복이란 손 닿는 곳에 있는 꽃들로 꽃다발을 만드는 솜씨.",
    author: "윌리엄 펠프스",
  },
  {
    sentence:
      "계획을 위해 쏟은 한 시간은 실행에 옮겼을 때 서너 시간을 절약시켜 준다.",
    author: "크로포드 그린 왈트",
  },
  {
    sentence: "불의는 참아도 불이익은 못 참는다.",
    author: "명언",
  },
  {
    sentence: "어느 누구에게나 친구는 어느 누구에게도 친구가 아니다.",
    author: "아리스토텔레스",
  },
  {
    sentence:
      "하고 싶은 건 해야 하고 하기 싫은 건 안 해야 한다는 그 생각이 속박이다.",
    author: "법륜스님",
  },
  {
    sentence: "겸손은 속옷과 같다. 입기는 입되 남에게 보이게는 입지 말라.",
    author: "탈무드",
  },
  {
    sentence: "서운함을 자주 느끼신다면 계산하는 버릇을 멈추세요.",
    author: "신준모",
  },
  {
    sentence: "별은 다 똑같이 빛나. 다만 빛나는 때가 조금씩 다를 뿐이지.",
    author: "작자미상",
  },
  {
    sentence:
      "첫 인상은 9할이 들어맞는다. 그럼에도 불구하고 1할을 위해 번거로워야 한다.",
    author: "클리앙",
  },
  {
    sentence:
      "접힌 자국은 쉽게 사라지지 않는다. 사랑했던 흔적은 말할 필요도 없다.",
    author: "김은주",
  },
  {
    sentence: "가장 못 나온게 실물이다.",
    author: "작자미상",
  },
  {
    sentence: "평온한 바다는 결코 유능한 뱃사람을 만들 수 없다.",
    author: "영국 속담",
  },
  {
    sentence: "인생은 속도가 아니라 방향이다.",
    author: "괴테",
  },
  {
    sentence:
      "사람의 마음은 낙하산과 같아서 활짝 펼쳤을 때 제 기능을 발휘한다.",
    author: "토머스 듀어",
  },
  {
    sentence: "기쁨을 나눴더니 질투가 되고 슬픔을 나눴더니 약점이 되더라",
    author: "작자미상",
  },
  {
    sentence:
      "어느 곳을 향해 배를 저어야 할 지 모르는 사람에게는 어떤 바람도 순풍이 될 수 없다.",
    author: "미셸 퐁테뉴",
  },
  {
    sentence: "많은 사람이 재능의 부족보다 결심의 부족으로 실패한다.",
    author: "빌리 선데이",
  },
  {
    sentence: "앉은 자리를 바꾸지 않으면 새로운 풍경을 볼 수 없다.",
    author: "김은주",
  },
  {
    sentence: "홍시여 이 사실을 잊지 말게. 너도 젊었을 때는 무척 떫었다는 걸",
    author: "나쓰메 소세키",
  },
  {
    sentence:
      "별똥 떨어진 곳 마음에 두었다. 다음 날 가 보려 벼르고 벼르다 이젠 다 자랐소.",
    author: "정지용",
  },
  {
    sentence:
      "사람의 부탁을 들어주는 것이 싫은 게 아니라 부탁할 때만 연락 오는 것이 싫은 것이다.",
    author: "사유리",
  },
  {
    sentence: "인생의 목표는 지식이 아니라 행동이다.",
    author: "올더스 헉슬리",
  },
  {
    sentence:
      "근심은 칼날에 스는 녹과 같다. 기계를 못 쓰게 만드는 것은 계속 된 사용이 아니라 마찰이다.",
    author: "헨리 워드 비처",
  },
  {
    sentence:
      "위대한 희망은 위대한 인물을 만든다. 산은 오르는 사람에게만 정복된다.",
    author: "토머스 풀러",
  },
  {
    sentence: "화려한 성공 뒤에는 반드시 화려하지 않은 준비가 있었다.",
    author: "지그 지글러",
  },
  {
    sentence: "화는 참아야 하는 것이 아니라 다스려야 하는 것이다.",
    author: "틱 낙한 스님",
  },
  {
    sentence: "내 것이라고 생각하면 우산 위의 눈도 가볍게 느껴지네",
    author: "기가쿠",
  },
  {
    sentence: "행복의 반대말은 불행이 아니라 불만이다.",
    author: "정철",
  },
  {
    sentence: "시험 기간에는 벽을 쳐다보고 있는 것 조차 흥미롭다.",
    author: "작자미상",
  },
  {
    sentence:
      "진주는 해변에서 뒹굴지 않는다. 진주를 얻으려면 바다 깊은 곳으로 잠수해야 한다.",
    author: "동양속담",
  },
  {
    sentence: "누구나 외롭다. 누구나 힘들다. 다들 아닌 척 살아갈 뿐이다.",
    author: "신준모",
  },
  {
    sentence:
      "성공은 절대 실수 하지 않는 것이 아니라, 똑같은 실수를 반복하지 않는 것이다.",
    author: "헨리 휠러 쇼",
  },
  {
    sentence: "걱정을 해서 걱정이 없어지면 걱정이 없겠네.",
    author: "티베트 속담",
  },
  {
    sentence: "상대방을 위한다고 충고 하는것 보단 밥 한 끼 사주는 편이 낫다.",
    author: "하명희",
  },
  {
    sentence:
      "이 세상에서 가장 열기 어려운 것은 '이미 다 안다'고 생각하는 사람의 마음의 문이다.",
    author: "신형철",
  },
  {
    sentence:
      "단 한 가닥의 머리털이라도 유혹의 바퀴에 끼이면 온 몸이 말려든다.",
    author: "헨리 아미엘",
  },
  {
    sentence:
      "시간을 최악으로 사용하는 사람들은 시간이 부족하다고 늘 불평하는데 일인자다.",
    author: "라 브뤼에르",
  },
  {
    sentence:
      "현명한 사람은 항상 침묵하는 사람이 아니라 언제 침묵해야 할지를 아는 사람이다.",
    author: "혜광스님",
  },
  {
    sentence:
      "재능 가운데 가장 소중한 재능은 한 마디면 될 때, 두 마디 말하지 않는 재주이다.",
    author: "토마스 제퍼슨",
  },
  {
    sentence: "만남은 인연이고 관계는 노력이다.",
    author: "양광모",
  },
  {
    sentence:
      "어떤 사람들은 자신이 3루에서 태어났으면서도 3루타를 친 줄 알고 살아간다.",
    author: "베리 스위쳐",
  },
  {
    sentence: "걱정은 흔들의자와 같다. 계속 움직이지만 아무데도 가지 않는다.",
    author: "월 로저스",
  },
  {
    sentence: "혼자 있는 것을 좋아하지만 혼자라고 느껴지는 것은 싫다.",
    author: "작자미상",
  },
  {
    sentence:
      "'때문에'라고 말하는 사람보다 '덕분에'라고 말하는 사람이 성공한다.",
    author: "양광모",
  },
  {
    sentence:
      "사람들은 당신이 한 말은 금방 잊어버리지만 당신이 그들에게 준 느낌은 항상 기억할 것이다.",
    author: "워렌 비티",
  },
  {
    sentence:
      "칭찬에 흔들리지 않는 사람도 자기의 이야기를 열심히 들어주는 사람에게는 마음이 흔들린다.",
    author: "잭 우드포드",
  },
  {
    sentence: "즐길 수 없으면 피하라.",
    author: "작자미상",
  },
  {
    sentence: "하고 싶은 일을 하기 위해 해야 하는 일을 하지 않으면 안된다.",
    author: "도슨트",
  },
  {
    sentence:
      "무사태평으로 보이는 사람들도 마음속 깊은 곳을 두드려보면 어딘가 슬픈 소리가 난다.",
    author: "나쓰메 소세키",
  },
  {
    sentence: "말을 많이 한다는 것과 잘한다는 것은 별개이다.",
    author: "소포클레스",
  },
  {
    sentence:
      "처음에는 우리가 습관을 만들지만 그 다음에는 습관이 우리를 만든다.",
    author: "존 드라이든",
  },
  {
    sentence: "길을 아는 것과 그 길을 걷는 것은 분명히 다르다.",
    author: "모피어스",
  },
  {
    sentence:
      "무관심의 가면 뒤에는 심한 고통이 있고 냉정한 태도 이면에는 실망감이 숨어있다.",
    author: "존 볼비",
  },
  {
    sentence:
      "바람이 불지 않을 때 바람개비를 돌리는 방법은 앞으로 달려가는 것이다.",
    author: "데일 카네기",
  },
  {
    sentence: "천재성은 누구나 가질 수 없지만 인내심은 누구나 가질 수 있다.",
    author: "작자미상",
  },
  {
    sentence: "칭찬은 고래도 춤추게 하지만 아첨은 사자도 넘어지게 합니다.",
    author: "조정민 목사",
  },
  {
    sentence:
      "원하는 것 가운데 몇 가지를 이루지 못하고 사는 것이 행복을 위한 필수 조건이다.",
    author: "보트런드 러셀",
  },
  {
    sentence: "걱정 없는 인생을 바라지말고 걱정에 물들지 않는 연습을 하라.",
    author: "알랭",
  },
  {
    sentence: "오늘 적극적으로 실행한 계획은 내일의 완벽한 계획보다 훨씬 낫다.",
    author: "조지 패튼",
  },
  {
    sentence:
      "넘어진 것은 당신의 잘못이 아닐 수 있다. 그러나 일어서지 않는 것은 당신의 잘못이다.",
    author: "스티브 데이비스",
  },
  {
    sentence: "어떻게 말할까 하고 괴로울 땐 진실을 말하라.",
    author: "마크 트웨인",
  },
  {
    sentence:
      "어둡다고 불평하기 보다는 작은 촛불을 하나라도 더 켜는 것이 낫다.",
    author: "공자",
  },
  {
    sentence:
      "오늘의 식사는 내일로 미루지 않으면서 오늘 할 일은 내일로 미루는 사람이 많다.",
    author: "칼 힐티",
  },
  {
    sentence:
      "한겨울 추운 날씨가 되어서야 소나무 잣나무가 시들지 않음을 알 수 있다.",
    author: "추사 김정희",
  },
  {
    sentence:
      "목표한 일을 이루는 것은 성공이지만 그 일을 하는 과정을 즐기는 것은 행복이다.",
    author: "베스 사위",
  },
  {
    sentence:
      "최고의 협상은 내가 원하는 바를 상대방이 말하거나 행하게 하는 것이다.",
    author: "베스 사위",
  },
  {
    sentence: "재능이 있어도 노력하지 않는다면 노력이 재능을 뛰어넘는다.",
    author: "팀 낫케",
  },
  {
    sentence: "사소한 것들을 소중히 해야 해. 그것이 삶을 이루는 버팀목이니까.",
    author: "심슨네 가족들",
  },
  {
    sentence: "무식한 자가 신념을 가지면 무서워진다.",
    author: "이경규",
  },
  {
    sentence: "생각하는 쪽으로 삶은 스며든다.",
    author: "은희경",
  },
  {
    sentence:
      "하늘 위 저 별을 따준다는 그의 말은 땅 위 한송이 꽃을 꺾어주는 행동보다 감동적이지 않다.",
    author: "김은주",
  },
  {
    sentence:
      "풍요 속에서는 친구들이 나를 알게 되고 역경 속에서는 내가 친구를 알게 된다.",
    author: "존 철튼 콜린스",
  },
  {
    sentence:
      "나중에 알찬 열매만 맺을 수 있다면 지금 당장 꽃이 아니라고 슬퍼 할 이유가 없지 않은가.",
    author: "이정하",
  },
  {
    sentence:
      "내 마음을 남이 어떻게 할 수 없듯이 나도 남의 마음을 어떻게 할 수 없다.",
    author: "전현수",
  },
  {
    sentence:
      "악행은 언제나 미덕보다 쉽다. 왜냐하면 악행은 모든 일에 지름길을 택하기 때문이다.",
    author: "존스",
  },
  {
    sentence:
      "모든 삶이 정각에 출발하는 건 아니야. 모든 삶이 정각에 도착하는 것도 아니지.",
    author: "칼 필레머",
  },
  {
    sentence:
      "선거란 누구를 뽑기 위해서가 아니라 누구를 뽑지 않기 위해 투표하는것이다.",
    author: "프랭클린 P. 애덤스",
  },
  {
    sentence: "멈추지 않는 이상 얼마나 천천히 가는지는 문제가 되지 않는다.",
    author: "공자",
  },
  {
    sentence: "아름다운 시작보다 아름다운 끝을 선택해라.",
    author: "발타자르 그라시안",
  },
  {
    sentence:
      "지금으로부터 1년 후 오늘 시작했더라면 좋았을 걸 하고 바랄 수 있다.",
    author: "카렌 램",
  },
  {
    sentence:
      "진정한 발견의 여정은 새로운 경치를 찾아다니는 게 아니라 새로운 눈으로 보는 것이다.",
    author: "마르셀 프루스트",
  },
  {
    sentence:
      "사람의 성품은 역경을 이겨낼 때가 아니라 권력이 주어졌을 때 가장 잘 드러난다.",
    author: "에이브러햄 링컨",
  },
  {
    sentence:
      "밥 사주는 것이 싫은 게 아니라 당연히 내가 사줄 거라고 생각하고 있는 것이 싫다.",
    author: "사유리",
  },
  {
    sentence:
      "생각이 떠올랐을 때에는 메모를 하자. 이것이 모든 성공의 출발점이다.",
    author: "나가오카 켄메이",
  },
  {
    sentence:
      "인내란 단순히 기다리는 능력이 아니다. 기다리는 동안 어떻게 행동하느냐가 중요하다.",
    author: "조이스 마이어",
  },
  {
    sentence:
      "다른 사람이 들어오지 못하도록 울타리를 치는 사람은 자신도 그 안에 갇히고 만다.",
    author: "빌 코플랜드",
  },
  {
    sentence: "사람이 태어나서 배우지 않으면 어두운 밤길을 가는 것과 같다.",
    author: "강태공",
  },
  {
    sentence:
      "벽돌이 쌓인다고 집이 되지 않듯이 시간이 쌓인다고 삶이 만들어지지 않는다.",
    author: "에리스 로럴드 미리에라",
  },
  {
    sentence:
      "때로는 푹 쉬도록 하라. 한 해 놀린 밭에서 풍성한 수확이 나오는 법이다.",
    author: "오비디우스",
  },
  {
    sentence:
      "우리가 가진 능력보다 진정한 우리를 훨씬 잘 보여주는 것은 우리의 선택이다.",
    author: "조앤 K. 롤링",
  },
  {
    sentence: "다른 사람들과 비슷하지 않다는 것은 흠이 아니라 매력이다.",
    author: "신경숙",
  },
  {
    sentence:
      "인생은 놀이공원이야. 해볼 건 다 해보고 나가야지 본전을 건지는 거야.",
    author: "김연수",
  },
  {
    sentence: "문을 나서면 여행의 가장 어려운 관문은 지난 셈이다.",
    author: "네덜란드 격언",
  },
  {
    sentence:
      "방치된 정원에 잡초가 자라듯 노력하지 않는 사랑은 어느새 다른 감정들에 의해 가려진다.",
    author: "앙드레 모로아",
  },
  {
    sentence: "희망차게 여행하는 것이 목적지에 도착하는 것보다 좋다.",
    author: "로버트 루이스 스티븐슨",
  },
  {
    sentence: "오늘 나의 불행은 언젠가 내가 잘못 보낸 시간의 보복이다.",
    author: "나폴레옹",
  },
  {
    sentence: "언젠가 내가 발음한 단어들이 나를 그곳으로 안내할 것이다.",
    author: "신혜정",
  },
  {
    sentence:
      "노력이 없는 관계는 유지되지 않지만 노력만 남은 관계도 유지되지 않더라.",
    author: "하상욱",
  },
  {
    sentence:
      "행복한 가정은 서로 닮았지만 불행한 가정은 저마다의 이유로 불행하다.",
    author: "톨스토이",
  },
  {
    sentence:
      "상황은 사람을 구속하지 않는다. 단지 그 사람의 됨됨이를 드러내줄 뿐이다.",
    author: "작자미상",
  },
  {
    sentence:
      "고기와 밀가루 식품을 안 먹으면 장수한다지만 그것을 안 먹으면 딱히 장수할 이유가 없어.",
    author: "김봉팔",
  },
  {
    sentence:
      "아무때나 포기하지 마라. 성공에도 때가 있듯이 포기에도 때가 있기 마련이다.",
    author: "양광모",
  },
  {
    sentence:
      "실패하는 사람은 거친 파도를 보고 성공하는 사람은 그 너머의 대륙을 본다.",
    author: "문상진/서범석",
  },
  {
    sentence: "더 가까워질 수 없는 사람들은 딱 그 만큼의 좋은 인연일지도 몰라.",
    author: "이동영",
  },
  {
    sentence: "견디는 것이 아니라 견디면서 나가는 것이 중요하다.",
    author: "서상영",
  },
  {
    sentence: "좌절의 시간들은 잊어라. 그러나 그것이 준 교훈은 절대 잊지 마라.",
    author: "하버트 개서",
  },
  {
    sentence: "네가 말을 할 때에는 그 말이 침묵보다 나은 것이어야 한다.",
    author: "아라비아 속담",
  },
  {
    sentence:
      "노력한다고 항상 성공할 순 없지만 성공한 사람은 모두 노력했단 걸 알아둬.",
    author: "곰돌이 푸",
  },
  {
    sentence: "의문은 '삶의 수준'을 결정하고 질문은 '삶 자체'를 바꾼다.",
    author: "팀 페리스",
  },
  {
    sentence:
      "애국자는 항상 조국을 위해 죽겠다고 하지만 조국을 위해 누군가를 죽이는 건 말하지 않는다.",
    author: "버트런드 러셀",
  },
  {
    sentence: "의심은 실패보다 더 많은 꿈을 사라지게 한다.",
    author: "수지 카셈",
  },
  {
    sentence:
      "인간은 슬픈 쪽으로만 평등하다. 인간은 어쩌면 행복한 쪽으로는 늘 불평등했다.",
    author: "백영옥",
  },
  {
    sentence:
      "가장 현명한 사람은 빈틈없는 사람이 아니라 쉴틈을 만드는 사람이다.",
    author: "양광모",
  },
  {
    sentence: "인간은 합리적인 동물이 아니라 합리화하는 동물이다.",
    author: "로버트 하인라인",
  },
  {
    sentence: "좋은 계획을 망치는 최대의 적은 완벽한 계획을 만들려는 꿈이다.",
    author: "칼 폰 클라우제비츠",
  },
  {
    sentence: "벼이삭을 잡아당긴다고 벼가 빨리 자라지 않는다.",
    author: "퇴계 이황",
  },
  {
    sentence: "낮은 자존감은 계속 브레이크를 밟으며 운전하는 것과 같다.",
    author: "맥스웰 말츠",
  },
  {
    sentence:
      "그를 잘 안다고 확신하면 반드시 실망한다. 평생 알아간다 생각하면 오래 함께한다.",
    author: "강원상",
  },
  {
    sentence: "기둥이 약하면 집이 흔들리듯 의지가 약하면 생활도 휘청거린다.",
    author: "랄프 왈도 에머슨",
  },
  {
    sentence:
      "기분 좋을 때만 잘한다면 당신은 인생에서 많은 것을 이루어 내지 못할 것이다.",
    author: "제리 웨스트",
  },
  {
    sentence:
      "가장 중요한 일들이 별로 중요하지 않은 일에 의해 좌우되어서는 안 된다.",
    author: "괴테",
  },
  {
    sentence: "장기적인 과정에서 봤을 때 지름길이라는 것은 없다.",
    author: "말콤 포브스",
  },
  {
    sentence: "항상 이길 수는 없지만 항상 배울 수는 있습니다.",
    author: "데니스 홍",
  },
  {
    sentence: "사람들은 옳은 사람들의 말 안들어. 좋아하는 사람의 말을 듣지.",
    author: "최규석",
  },
  {
    sentence:
      "나를 슬럼프에 빠트리게 한 가장 큰 요인은 '안된다'라는 생각이었다.",
    author: "박찬호",
  },
  {
    sentence: "후회는 아무리 빨라도 늦고 시작은 아무리 늦어도 빠르다.",
    author: "작자미상",
  },
  {
    sentence:
      "삶은 생각할수록 비극이지만 그래도 즐겁게 살려고 마음을 먹으면 즐거운 게 꽤 많다.",
    author: "작자미상",
  },
  {
    sentence: "편안함이 끝나고 궁핍이 시작될 때 인생의 가르침이 시작된다.",
    author: "헤르만 헤세",
  },
  {
    sentence:
      "술이 사람을 못된놈으로 만드는 것이 아니라 그 사람이 원래 못된 놈이라는 것을 술이 밝혀준다.",
    author: "일본 명언",
  },
  {
    sentence:
      "좋은 기회를 만나지 못했던 사람은 하나도 없다. 그것을 잡지 못했을 뿐이다.",
    author: "데일 카네기",
  },
  {
    sentence: "하고 싶은 일에는 방법이 보이고 하기 싫은 일에는 핑계가 보인다.",
    author: "필리핀 격언",
  },
  {
    sentence: "절망하지 마라. 종종 열쇠 꾸러미의 마지막 열쇠가 자물쇠를 연다.",
    author: "필립 체스터필드",
  },
  {
    sentence: "신은 너의 내면을 보지만 사람들은 너의 겉 모습을 먼저 본다.",
    author: "이민규",
  },
  {
    sentence: "음악에서 가장 중요한 것은 악보에 기록되어 있지 않다.",
    author: "구스타프 말러",
  },
  {
    sentence:
      "우리가 출발한 곳은 선택할 수 없지만 어딜 향해 갈지는 선택할 수 있어.",
    author: "월플라워",
  },
  {
    sentence:
      "자기 자신을 존중하되 자만하지 말라. 자신의 능력을 키우되 과신하지 말라",
    author: "탈무드",
  },
  {
    sentence: "문제는 원래 터지기 마련이고 그걸 해결하는 게 중요하지.",
    author: "바조우",
  },
  {
    sentence:
      "자기가 틀렸다는 사실을 인정하기란 어렵다. 특히나 무척 오랫동안 틀린 채로 살아왔을 때는.",
    author: "프레드릭 배크만",
  },
  {
    sentence: "당신이 할 수 있다고 믿든 할 수 없다고 믿든 믿는 대로 될 것이다.",
    author: "헨리 포드",
  },
  {
    sentence: "항해술에서 가장 중요한 것은 선박의 위치 판단이다.",
    author: "김훈",
  },
  {
    sentence: "일단 부딪쳐보는 거다. 실패했을 땐 후회하면 되지.",
    author: "쿠스미 마사유키",
  },
  // 삶의 지혜
  {
    sentence: "오늘 할 수 있는 일을 내일로 미루지 마라.",
    author: "벤저민 프랭클린",
  },
  {
    sentence: "천 리 길도 한 걸음부터 시작된다.",
    author: "노자",
  },
  {
    sentence: "실패는 성공의 어머니다.",
    author: "토마스 에디슨",
  },
  {
    sentence: "작은 기회로부터 종종 위대한 업적이 시작된다.",
    author: "데모스테네스",
  },
  {
    sentence: "인생은 자전거를 타는 것과 같다. 균형을 잡으려면 움직여야 한다.",
    author: "알베르트 아인슈타인",
  },
  {
    sentence: "가장 큰 영광은 한 번도 실패하지 않음이 아니라 실패할 때마다 다시 일어서는 것이다.",
    author: "공자",
  },
  {
    sentence: "시간은 금이다.",
    author: "벤저민 프랭클린",
  },
  {
    sentence: "아는 것이 힘이다.",
    author: "프랜시스 베이컨",
  },
  {
    sentence: "생각하는 대로 살지 않으면 사는 대로 생각하게 된다.",
    author: "폴 발레리",
  },
  {
    sentence: "삶이 있는 한 희망은 있다.",
    author: "키케로",
  },
  {
    sentence: "기회는 준비된 자에게 온다.",
    author: "루이 파스퇴르",
  },
  // 철학
  {
    sentence: "나는 생각한다. 고로 존재한다.",
    author: "르네 데카르트",
  },
  {
    sentence: "너 자신을 알라.",
    author: "소크라테스",
  },
  {
    sentence: "인생은 가까이서 보면 비극이지만 멀리서 보면 희극이다.",
    author: "찰리 채플린",
  },
  {
    sentence: "행복은 자기 자신에게 달려 있다.",
    author: "아리스토텔레스",
  },
  {
    sentence: "진정한 지혜는 자신이 아무것도 모른다는 것을 아는 것이다.",
    author: "소크라테스",
  },
  {
    sentence: "삶은 짧고 예술은 길다.",
    author: "히포크라테스",
  },
  {
    sentence: "사람은 자유를 선고받은 존재다.",
    author: "장 폴 사르트르",
  },
  {
    sentence: "모든 것은 변한다. 변하지 않는 것은 변한다는 사실뿐이다.",
    author: "헤라클레이토스",
  },
  {
    sentence: "상식은 세상에서 가장 잘 분배된 것이다.",
    author: "르네 데카르트",
  },
  // 과학
  {
    sentence: "상상력은 지식보다 중요하다.",
    author: "알베르트 아인슈타인",
  },
  {
    sentence: "자연은 단순함을 좋아한다.",
    author: "아이작 뉴턴",
  },
  {
    sentence: "나는 단지 호기심이 많을 뿐이다.",
    author: "알베르트 아인슈타인",
  },
  {
    sentence: "과학은 체계화된 지식이고 지혜는 체계화된 삶이다.",
    author: "임마누엘 칸트",
  },
  {
    sentence: "발견의 기쁨은 인간이 느낄 수 있는 가장 큰 기쁨이다.",
    author: "클로드 베르나르",
  },
  {
    sentence: "질문하는 것을 멈추지 마라.",
    author: "알베르트 아인슈타인",
  },
  {
    sentence: "단순함이야말로 궁극의 정교함이다.",
    author: "레오나르도 다 빈치",
  },
  {
    sentence: "모든 것을 의심하라.",
    author: "르네 데카르트",
  },
  // 예술
  {
    sentence: "예술은 자연이 만들지 않은 것을 만드는 것이다.",
    author: "앙드레 말로",
  },
  {
    sentence: "색채는 영혼에 직접 영향을 미치는 힘이다.",
    author: "바실리 칸딘스키",
  },
  {
    sentence: "모든 어린이는 예술가다. 문제는 어른이 되어서도 예술가로 남느냐다.",
    author: "파블로 피카소",
  },
  {
    sentence: "나는 그리기 전에 눈을 감는다.",
    author: "파블로 피카소",
  },
  {
    sentence: "위대한 예술가는 훔친다.",
    author: "파블로 피카소",
  },
  {
    sentence: "음악이 있는 곳에 악한 것은 없다.",
    author: "세르반테스",
  },
  // 문학
  {
    sentence: "펜은 칼보다 강하다.",
    author: "에드워드 불워 리턴",
  },
  {
    sentence: "봄이 오면 산에 들에 진달래 피네.",
    author: "진달래꽃 - 김소월",
  },
  {
    sentence: "내 마음은 호수요, 그대 노 저어 오오.",
    author: "내 마음은 - 김동명",
  },
  {
    sentence: "가을에는 기도하게 하소서.",
    author: "가을의 기도 - 김현승",
  },
  // 비즈니스
  {
    sentence: "혁신은 리더와 추종자를 구분한다.",
    author: "스티브 잡스",
  },
  {
    sentence: "고객에게 집중하면 모든 것이 따라온다.",
    author: "제프 베조스",
  },
  {
    sentence: "완벽한 것보다 완성하는 것이 낫다.",
    author: "셰릴 샌드버그",
  },
  {
    sentence: "위험을 감수하지 않는 것이 가장 큰 위험이다.",
    author: "마크 저커버그",
  },
  {
    sentence: "성공은 매일 반복한 작은 노력의 합이다.",
    author: "로버트 콜리어",
  },
  {
    sentence: "불가능이란 노력하지 않는 자의 변명이다.",
    author: "나폴레옹 보나파르트",
  },
  // 스포츠
  {
    sentence: "승리는 가장 끈질긴 자의 것이다.",
    author: "나폴레옹 보나파르트",
  },
  {
    sentence: "이기는 습관을 만들어라.",
    author: "빈스 롬바르디",
  },
  // 속담
  {
    sentence: "가는 말이 고와야 오는 말이 곱다.",
    author: "속담",
  },
  {
    sentence: "낮말은 새가 듣고 밤말은 쥐가 듣는다.",
    author: "속담",
  },
  {
    sentence: "소 잃고 외양간 고친다.",
    author: "속담",
  },
  {
    sentence: "원숭이도 나무에서 떨어진다.",
    author: "속담",
  },
  {
    sentence: "등잔 밑이 어둡다.",
    author: "속담",
  },
  {
    sentence: "우물 안 개구리.",
    author: "속담",
  },
  {
    sentence: "티끌 모아 태산.",
    author: "속담",
  },
  {
    sentence: "백지장도 맞들면 낫다.",
    author: "속담",
  },
  {
    sentence: "세 살 버릇 여든까지 간다.",
    author: "속담",
  },
  {
    sentence: "아니 땐 굴뚝에 연기 나랴.",
    author: "속담",
  },
  {
    sentence: "뜻이 있는 곳에 길이 있다.",
    author: "속담",
  },
  {
    sentence: "고생 끝에 낙이 온다.",
    author: "속담",
  },
  {
    sentence: "하늘은 스스로 돕는 자를 돕는다.",
    author: "속담",
  },
  {
    sentence: "구슬이 서 말이라도 꿰어야 보배다.",
    author: "속담",
  },
  {
    sentence: "가랑비에 옷 젖는 줄 모른다.",
    author: "속담",
  },
  {
    sentence: "호랑이에게 물려가도 정신만 차리면 산다.",
    author: "속담",
  },
  {
    sentence: "될성부른 나무는 떡잎부터 알아본다.",
    author: "속담",
  },
  {
    sentence: "빈 수레가 요란하다.",
    author: "속담",
  },
  {
    sentence: "공든 탑이 무너지랴.",
    author: "속담",
  },
  {
    sentence: "우물을 파도 한 우물을 파라.",
    author: "속담",
  },
  {
    sentence: "말 한마디로 천 냥 빚을 갚는다.",
    author: "속담",
  },
  {
    sentence: "산이 높으면 골이 깊다.",
    author: "속담",
  },
  {
    sentence: "물방울이 바위를 뚫는다.",
    author: "속담",
  },
  {
    sentence: "비 온 뒤에 땅이 굳어진다.",
    author: "속담",
  },
  {
    sentence: "시작이 반이다.",
    author: "속담",
  },
  {
    sentence: "밥이 보약이다.",
    author: "속담",
  },
  {
    sentence: "금강산도 식후경이다.",
    author: "속담",
  },
  {
    sentence: "고양이는 아홉 개의 목숨이 있다.",
    author: "속담",
  },
  // 동양 철학
  {
    sentence: "지피지기면 백전백승이다.",
    author: "손자",
  },
  {
    sentence: "군자는 말보다 행동이 앞선다.",
    author: "공자",
  },
  {
    sentence: "배우고 때로 익히면 또한 기쁘지 아니한가.",
    author: "공자",
  },
  {
    sentence: "물처럼 낮은 곳으로 흐르라.",
    author: "노자",
  },
  {
    sentence: "스스로를 이기는 것이 가장 큰 승리다.",
    author: "노자",
  },
  {
    sentence: "천천히 가도 된다. 멈추지만 않으면.",
    author: "공자",
  },
  {
    sentence: "인내는 쓰나 그 열매는 달다.",
    author: "장 자크 루소",
  },
  {
    sentence: "자연은 서두르지 않으나 모든 것을 이룬다.",
    author: "노자",
  },
  {
    sentence: "멈추지 않으면 얼마나 느리게 가든 상관없다.",
    author: "공자",
  },
  // 창의성
  {
    sentence: "문제를 만든 사고방식으로는 문제를 해결할 수 없다.",
    author: "알베르트 아인슈타인",
  },
  {
    sentence: "다르게 생각하라.",
    author: "스티브 잡스",
  },
  {
    sentence: "실수는 발견의 문이다.",
    author: "제임스 조이스",
  },
  {
    sentence: "규칙을 배우고 나서 규칙을 깨라.",
    author: "파블로 피카소",
  },
  {
    sentence: "창의성은 연결하는 것이다.",
    author: "스티브 잡스",
  },
  {
    sentence: "상상할 수 있다면 이룰 수 있다.",
    author: "월트 디즈니",
  },
  // 인간관계
  {
    sentence: "친구는 제2의 자아다.",
    author: "아리스토텔레스",
  },
  // 자연/계절
  {
    sentence: "겨울이 오면 봄이 멀지 않다.",
    author: "퍼시 비시 셸리",
  },
  // 시간
  {
    sentence: "시간을 낭비하지 마라. 인생은 시간으로 이루어져 있다.",
    author: "벤저민 프랭클린",
  },
  {
    sentence: "하루하루가 일 년 중 가장 좋은 날이다.",
    author: "랠프 왈도 에머슨",
  },
  // 이솝 우화
  {
    sentence: "느림보 거북이가 경주에서 이겼다.",
    author: "이솝 우화",
  },
  {
    sentence: "부지런한 개미는 겨울에도 배고프지 않다.",
    author: "이솝 우화",
  },
];
